/**
 * Banner Product — Layout Orchestration v1.0
 * Kalite tab, desen seçimi, galeri yönetimi, config switch
 * Mevcut motorlara (ozel-olcu-plus.js, preview.min.js, amorf.js) DOKUNMAZ
 * 2026-04-13
 */
(function() {
  'use strict';

  // ========== GLOBAL REFERANSLAR ==========
  var _raw = window.__ALL_CONFIGS__ || {};
  // Config flat veya nested olabilir — her ikisini de destekle
  var allConfigs = { products: {}, qualityMeta: {} };
  if (_raw.products && typeof _raw.products === 'object') {
    // Nested yapı (config.json direkt inject)
    allConfigs = _raw;
  } else {
    // Flat yapı (tema sync inject — her ürün top-level key)
    var _keys = Object.keys(_raw);
    for (var _ki = 0; _ki < _keys.length; _ki++) {
      var _k = _keys[_ki];
      var _v = _raw[_k];
      if (_k === 'qualityMeta') { allConfigs.qualityMeta = _v; }
      else if (_v && typeof _v === 'object' && (_v.massimoApi || _v.shopifyHandles || _v.m2Price !== undefined)) {
        allConfigs.products[_k] = _v;
      }
    }
  }
  var currentConfig = window.__OZEL_OLCU_CONFIG__;
  var currentProductKey = null;
  var currentQualityKey = null;
  var qualityGroups = {};
  var qualityMeta = allConfigs.qualityMeta || {};
  // Shopify Admin denetimi: bu ozel olcu urunu taslak ve storefront'ta 404.
  // Stoklu gorunse bile desen/alternatif olarak musterinin onune cikmamali.
  var disabledStorefrontProductIds = { '6074282148011': true };

  // ========== DOM REFERANSLARI ==========
  var elQualityTabs = document.getElementById('bp-quality-tabs');
  var elPatterns = document.getElementById('bp-patterns');
  var elTitle = document.getElementById('bp-title');
  var elPatCode = document.getElementById('bp-pat-code');
  var elMainImage = document.getElementById('bp-product-img');
  var elThumbs = document.getElementById('bp-thumbs');
  var elDelivery = document.getElementById('bp-delivery');
  var elRelated = document.getElementById('bp-related');
  var elLiveBadge = document.getElementById('bp-live-badge');
  var elZoomBtn = document.getElementById('bp-zoom-trigger');

  // ========== INIT ==========
  function init() {
    if (!allConfigs || !allConfigs.products) {
      console.warn('[BannerProduct] __ALL_CONFIGS__ bulunamadı veya boş');
      return;
    }

    // Mevcut ürünün config key'ini bul
    currentProductKey = findCurrentProductKey();
    if (!currentProductKey) {
      console.warn('[BannerProduct] Mevcut ürün config\'de bulunamadı');
      return;
    }

    // Kaliteleri grupla
    buildQualityGroups();

    // Mevcut ürünün kalitesini bul
    var product = allConfigs.products[currentProductKey];
    currentQualityKey = normalizeQualityKey(product.qualityCode || '');

    // Stok bulunamadiginda ozel-olcu motorunun yalnizca ayni kalite icindeki
    // desenlere guvenli bir sekilde gecis yapabilmesi icin dar kapsamli kopru.
    installPatternBridge();

    // UI oluştur
    renderQualityTabs();
    renderPatterns(currentQualityKey);
    highlightCurrentPattern();
    renderDeliveryTimeline();
    renderRelated(currentQualityKey);
    initGalleryThumbs();
    initZoom();

    // Ana stok/fiyat akisini bekletmemesi icin tamamlayici urunleri bos zamanda yukle.
    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(loadComplementary, { timeout: 4000 });
    } else {
      setTimeout(loadComplementary, 2000);
    }

    // Kalite/desen değişiminde "Tasarlanıyor..." overlay (mobilde donmuş hissi önler)
    installQualityLoader();

    // Mobilde galeri aç/kapa toggle + parmakla swipe (yer kazanma + şık UX)
    installGalleryCollapse();
    installGallerySwipe();

    
    
    // bp-amorf-hero kaldirildi — fiyat slotu (bp-price-slot) aldi yerini

    // Amorf kota kontrolü
    (function checkAmorfKota() {
      var shapeSelect = document.getElementById('ozel-olcu-shape');
      if (shapeSelect && shapeSelect.getAttribute('data-amorf-enabled') === 'false') return;
      var OFFLINE_MSG = 'Üretim kapasitemiz dolmuştur, gün içerisinde uygunluk durumuna göre sistem otomatik olarak tekrar açılacaktır.';
      function showKapali(msg) {
        var card = document.getElementById('bp-amorf-hero');
        var kotaEl = document.getElementById('bp-amorf-kota');
        var kotaMsg = document.getElementById('bp-amorf-kota-msg');
        if (!card || !kotaEl) return;
        window.__amorfKotaKapali = true;
        card.classList.add('kota-kapali');
        kotaEl.style.display = 'flex';
        if (kotaMsg) kotaMsg.textContent = msg;
      }
      fetch('https://dolcevita-massimo.ngrok.io/api/amorf-kota')
        .then(function(r) {
          if (!r.ok) throw new Error('status ' + r.status);
          return r.json();
        })
        .then(function(k) {
          if (k.kapali) {
            showKapali(k.mesaj || 'Kapasite doldu — ' + (k.acilisSaati || '00:00') + "'da açılacak");
          }
        })
        .catch(function() {
          // Sunucu erişilemiyor → müşteriye kapasite doldu mesajı göster
          showKapali(OFFLINE_MSG);
        });
    })();

    // Teslimat tarihi hesapla — normal: 2-3 iş günü, amorf: +3 iş günü
    var _gunler = ['Pazar','Pazartesi','Salı','Çarşamba','Perşembe','Cuma','Cumartesi'];
    var _aylar = ['Ocak','Şubat','Mart','Nisan','Mayıs','Haziran','Temmuz','Ağustos','Eylül','Ekim','Kasım','Aralık'];
    
    function calcDeliveryDate(extraDays) {
      var _now = new Date();
      var _days = (_now.getHours() < 15 ? 2 : 3) + (extraDays || 0);
      var _dlv = new Date(_now);
      var _added = 0;
      while (_added < _days) {
        _dlv.setDate(_dlv.getDate() + 1);
        if (_dlv.getDay() !== 0 && _dlv.getDay() !== 6) _added++;
      }
      return _dlv.getDate() + ' ' + _aylar[_dlv.getMonth()] + ' ' + _gunler[_dlv.getDay()];
    }
    
    // Mini banner teslimat
    var _dlvEl = document.getElementById('bp-delivery-date');
    if (_dlvEl) _dlvEl.textContent = calcDeliveryDate(0) + ' Teslim';
    
    // Header teslimat
    var _hdrDlv = document.getElementById('bp-header-delivery');
    if (_hdrDlv) _hdrDlv.textContent = calcDeliveryDate(0);
    
    // Shape değiştiğinde teslimat tarihini güncelle
    var _shapeEl = document.getElementById('ozel-olcu-shape');
    if (_shapeEl) {
      _shapeEl.addEventListener('change', function() {
        var isAmorf = (this.value === 'amorf' || this.value === 'daire' || this.value === 'oval');
        var extra = isAmorf ? 3 : 0;
        var dateStr = calcDeliveryDate(extra);
        if (_dlvEl) _dlvEl.textContent = dateStr + ' Teslim';
        if (_hdrDlv) _hdrDlv.textContent = dateStr;
        // Header tag renk değişimi
        var tagEl = document.getElementById('bp-htag-teslimat');
        if (tagEl) tagEl.className = 'bp-htag bp-htag-teslimat' + (isAmorf ? ' amorf-mode' : '');
      });
    }

    // Tema lazy-load opacity fix
    var _bpImg = document.getElementById('bp-product-img');
    if (_bpImg) { _bpImg.style.opacity = '1'; _bpImg.style.removeProperty('opacity'); }
    console.log('[BannerProduct] v1.0 hazır — kalite:', currentQualityKey, 'desen:', currentProductKey);
  }

  // ========== ÜRÜN KEY BULMA ==========
  function findCurrentProductKey() {
    var banner = document.getElementById('banner-product');
    var handle = banner ? banner.getAttribute('data-product-handle') : '';
    var productId = banner ? banner.getAttribute('data-product-id') : '';

    if (!handle && !productId) return null;

    var products = allConfigs.products || {};
    var keys = Object.keys(products);

    for (var i = 0; i < keys.length; i++) {
      var p = products[keys[i]];
      var handles = p.shopifyHandles || {};
      if (handles.biye === handle || handles.bordur === handle || handles.overlok === handle) {
        return keys[i];
      }
      if (p.shopifyHandle === handle) return keys[i];
      if (Array.isArray(p.shopifyHandleAliases)) {
        for (var h = 0; h < p.shopifyHandleAliases.length; h++) {
          if (String(p.shopifyHandleAliases[h]) === String(handle)) return keys[i];
        }
      }
      if (Array.isArray(p.shopifyProductIdAliases)) {
        for (var id = 0; id < p.shopifyProductIdAliases.length; id++) {
          if (String(p.shopifyProductIdAliases[id]) === String(productId)) return keys[i];
        }
      }
    }
    return null;
  }

  // ========== KALİTE GRUPLAMA ==========
  function normalizeQualityKey(qualityCode) {
    return (qualityCode || '').toLowerCase().replace(/\s+/g, '-');
  }

  function buildQualityGroups() {
    qualityGroups = {};
    var products = allConfigs.products || {};
    var keys = Object.keys(products);

    for (var i = 0; i < keys.length; i++) {
      var p = products[keys[i]];
      var qk = normalizeQualityKey(p.qualityCode || '');
      if (!qk) continue;
      var productId = p.shopifyProductId || ((p.shopifyProductIds || {}).biye) || '';
      if (p.enabled === false || disabledStorefrontProductIds[String(productId)]) continue;
      // Icon is not a Dolce Vita cut-to-size quality. Keep it out even if a
      // stale generated config is deployed later.
      if (qk === 'icon') continue;

      if (!qualityGroups[qk]) {
        qualityGroups[qk] = {
          label: p.qualityCode || qk,
          products: []
        };
      }
      qualityGroups[qk].products.push({
        key: keys[i],
        patternCode: p.patternCode || '',
        patternImage: p.patternImage || '',
        patternBg: p.patternBg || '',
        handle: (p.shopifyHandles || {}).biye || (p.shopifyHandles || {}).overlok || ''
      });
    }
  }

  function installPatternBridge() {
    window.__OzelOlcuPatternBridge = {
      currentKey: function() {
        return currentProductKey;
      },
      qualityLabel: function() {
        var group = qualityGroups[currentQualityKey] || {};
        var meta = qualityMeta[currentQualityKey] || {};
        return meta.label || group.label || currentQualityKey || '';
      },
      getSameQualityPatterns: function() {
        var group = qualityGroups[currentQualityKey];
        if (!group || !group.products) return [];

        return group.products.map(function(product) {
          return {
            key: product.key,
            patternCode: product.patternCode,
            patternImage: product.patternImage,
            patternBg: product.patternBg,
            config: (allConfigs.products || {})[product.key] || null
          };
        });
      },
      select: function(productKey) {
        var config = (allConfigs.products || {})[productKey];
        if (!config) return false;

        // Alternatif stok karti baska bir kaliteye gecis yaptiramaz.
        if (normalizeQualityKey(config.qualityCode || '') !== currentQualityKey) return false;
        if (productKey !== currentProductKey) setPattern(productKey);
        return true;
      }
    };

    window.dispatchEvent(new CustomEvent('ozel-olcu:pattern-bridge-ready'));
  }

  // ========== KALİTE TAB RENDER ==========
  function renderQualityTabs() {
    if (!elQualityTabs) return;

    elQualityTabs.setAttribute('role', 'tablist');
    elQualityTabs.setAttribute('aria-label', 'Halı kaliteleri');

    // sortOrder'a göre sırala
    var sortedKeys = Object.keys(qualityGroups).sort(function(a, b) {
      var ma = qualityMeta[a] || {};
      var mb = qualityMeta[b] || {};
      return (ma.sortOrder || 99) - (mb.sortOrder || 99);
    });

    var html = '';
    for (var i = 0; i < sortedKeys.length; i++) {
      var qk = sortedKeys[i];
      var g = qualityGroups[qk];
      var meta = qualityMeta[qk] || {};
      var label = meta.label || g.label || qk;
      var isActive = (qk === currentQualityKey) ? ' active' : '';
      html += '<button class="bp-qtab' + isActive + '" data-quality="' + qk + '" role="tab" aria-selected="' + (qk === currentQualityKey ? 'true' : 'false') + '">' + escapeHtml(label) + '</button>';
    }
    elQualityTabs.innerHTML = html;

    // Dar ekranlarda son siradaki aktif kalite (Macaron gibi) ekran disinda
    // kalmasin. Ilk acilista ve ekran yonu degisince aktif tab ortalanir.
    requestAnimationFrame(function() { centerActiveQualityTab('auto'); });
    // Tarayicinin yatay scroll-restoration'i ilk frame'den sonra devreye
    // girebildigi icin iki gecikmeli kontrol aktif tabin kaybolmasini onler.
    setTimeout(function() { centerActiveQualityTab('auto'); }, 180);
    setTimeout(function() { centerActiveQualityTab('auto'); }, 700);
    setTimeout(function() { centerActiveQualityTab('auto'); }, 1500);
    setTimeout(function() { centerActiveQualityTab('auto'); }, 3000);
    if (!elQualityTabs._bpCenterBound) {
      elQualityTabs._bpCenterBound = true;
      var resizeTimer = null;
      window.addEventListener('resize', function() {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function() { centerActiveQualityTab('auto'); }, 120);
      }, { passive: true });
      window.addEventListener('pageshow', function() {
        setTimeout(function() { centerActiveQualityTab('auto'); }, 80);
      }, { passive: true });
    }

    // Event delegation
    elQualityTabs.addEventListener('click', function(e) {
      var tab = e.target.closest('.bp-qtab');
      if (!tab) return;
      var qk = tab.getAttribute('data-quality');
      if (qk && qk !== currentQualityKey) {
        navigateToQuality(qk);
      }
    });
  }

  function centerActiveQualityTab(behavior) {
    if (!elQualityTabs || elQualityTabs.scrollWidth <= elQualityTabs.clientWidth) return;
    var active = elQualityTabs.querySelector('.bp-qtab.active');
    if (!active) return;

    var tabsRect = elQualityTabs.getBoundingClientRect();
    var activeRect = active.getBoundingClientRect();
    var targetLeft = elQualityTabs.scrollLeft + (activeRect.left - tabsRect.left) -
      ((elQualityTabs.clientWidth - activeRect.width) / 2);
    var maxLeft = Math.max(0, elQualityTabs.scrollWidth - elQualityTabs.clientWidth);
    targetLeft = Math.max(0, Math.min(maxLeft, targetLeft));

    var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    elQualityTabs.scrollTo({
      left: targetLeft,
      behavior: reducedMotion ? 'auto' : (behavior || 'smooth')
    });
  }

  // ========== MOBİL THUMB ŞERİDİ AÇ/KAPA ==========
  // Mobilde (<768px) ana görsel + rulerlar HER ZAMAN görünür. Sadece alttaki
  // thumbnail şeridi (bp-gallery__thumbs) varsayılan KAPALI, aşağı ok ile açılır.
  function installGalleryCollapse() {
    if (window.innerWidth >= 768) return; // Sadece mobil
    var thumbs = document.getElementById('bp-thumbs');
    if (!thumbs) return;
    if (document.getElementById('bp-gallery-toggle')) return;

    // CSS enjekte et
    if (!document.getElementById('bp-gallery-collapse-css')) {
      var st = document.createElement('style');
      st.id = 'bp-gallery-collapse-css';
      st.textContent =
        '@media (max-width: 767px) {' +
          '#bp-thumbs { overflow:hidden; transition: max-height 320ms ease, padding 320ms ease; max-height: 200px; }' +
          '#bp-thumbs.bp-thumbs--collapsed { max-height: 0 !important; padding-top: 0 !important; padding-bottom: 0 !important; }' +
          '.bp-gallery-toggle { position: relative; width: 100%; height: 30px; background: #fff; border: none; border-top: 1px solid #eee; border-bottom: 1px solid #eee; cursor: pointer; display: flex; align-items: center; justify-content: center; gap: 8px; font-size: 11px; color: #777; font-weight: 500; letter-spacing: 0.3px; padding: 0; }' +
          '.bp-gallery-toggle__chev { width: 11px; height: 11px; transition: transform 260ms ease; display:inline-block; }' +
          '.bp-gallery-toggle.is-open .bp-gallery-toggle__chev { transform: rotate(180deg); }' +
          '.bp-gallery-toggle:active { background: #f9f9f9; }' +
        '}';
      document.head.appendChild(st);
    }

    var btn = document.createElement('button');
    btn.id = 'bp-gallery-toggle';
    btn.className = 'bp-gallery-toggle';
    btn.type = 'button';
    btn.setAttribute('aria-expanded', 'false');
    btn.setAttribute('aria-controls', 'bp-thumbs');
    // Inline stil — CSS class'a güvenmeyelim (parent pointer-events/stacking sorunlarına karşı)
    btn.style.cssText = 'position:relative;z-index:20;width:100%;height:32px;background:#fff;border:none;border-top:1px solid #eee;border-bottom:1px solid #eee;cursor:pointer;display:flex;align-items:center;justify-content:center;gap:8px;font-size:11px;color:#555;font-weight:500;letter-spacing:0.3px;padding:0;pointer-events:auto;touch-action:manipulation;-webkit-tap-highlight-color:rgba(232,98,42,0.15);';
    btn.innerHTML =
      '<span class="bp-gallery-toggle__text" style="pointer-events:none;">Diğer Görseller</span>' +
      '<svg class="bp-gallery-toggle__chev" viewBox="0 0 12 12" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" style="width:11px;height:11px;transition:transform 260ms ease;display:inline-block;pointer-events:none;"><path d="M2 4.5 L6 8.5 L10 4.5"/></svg>';
    // Toggle butonu thumbs'ın HEMEN ÜSTÜNE koy
    thumbs.parentNode.insertBefore(btn, thumbs);

    // Varsayılan: thumb şeridi kapalı
    thumbs.classList.add('bp-thumbs--collapsed');
    var txt = btn.querySelector('.bp-gallery-toggle__text');
    var chev = btn.querySelector('.bp-gallery-toggle__chev');

    function doToggle(e) {
      if (e) { e.preventDefault(); e.stopPropagation(); }
      var collapsed = thumbs.classList.toggle('bp-thumbs--collapsed');
      btn.classList.toggle('is-open', !collapsed);
      btn.setAttribute('aria-expanded', String(!collapsed));
      if (txt) txt.textContent = collapsed ? 'Diğer Görseller' : 'Görselleri Gizle';
      if (chev) chev.style.transform = collapsed ? 'rotate(0deg)' : 'rotate(180deg)';
      console.log('[Gallery] Thumbs', collapsed ? 'KAPALI' : 'AÇIK');
    }
    btn.addEventListener('click', doToggle);
    // Mobil: touchend ile de tetikle (bazı overlay'lerin click'i yuttuğu durumlara karşı)
    btn.addEventListener('touchend', function(e) {
      if (e.cancelable) e.preventDefault();
      doToggle(e);
    }, { passive: false });
  }

  // ========== MOBİL GALERİ SWIPE ==========
  // Ana görsel üzerinde parmakla sağa-sola kaydırınca thumbnail'ler arasında gezinir.
  // Thumbnail click handler mevcut onChange akışını tetikler (1. resim amorf giydirme
  // gösterir, 2+ resim orijinal product görselleri).
  function installGallerySwipe() {
    var main = document.getElementById('bp-main-image');
    if (!main || main._swipeInit) return;
    main._swipeInit = true;
    var x0 = null, y0 = null, t0 = 0, active = false;
    main.addEventListener('touchstart', function(e) {
      if (!e.touches || e.touches.length !== 1) return;
      x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; t0 = Date.now(); active = true;
    }, { passive: true });
    main.addEventListener('touchmove', function(e) {
      if (!active || !e.touches || e.touches.length !== 1) return;
      var dx = e.touches[0].clientX - x0;
      var dy = e.touches[0].clientY - y0;
      // Dikey kaydırma → iptal (sayfa scroll'a bırak)
      if (Math.abs(dy) > Math.abs(dx) && Math.abs(dy) > 10) active = false;
    }, { passive: true });
    main.addEventListener('touchend', function(e) {
      if (!active) return;
      active = false;
      var touch = (e.changedTouches && e.changedTouches[0]) || null;
      if (!touch) return;
      var dx = touch.clientX - x0;
      var dt = Date.now() - t0;
      if (Math.abs(dx) < 40 || dt > 600) return; // çok küçük veya yavaş → swipe sayma
      var thumbs = document.querySelectorAll('#bp-thumbs .bp-thumb');
      if (thumbs.length < 2) return;
      var activeIdx = 0;
      for (var i = 0; i < thumbs.length; i++) {
        if (thumbs[i].classList.contains('active')) { activeIdx = i; break; }
      }
      var nextIdx;
      if (dx < 0) { // sola swipe → sonraki
        nextIdx = activeIdx + 1;
        if (nextIdx >= thumbs.length) return;
      } else { // sağa swipe → önceki
        nextIdx = activeIdx - 1;
        if (nextIdx < 0) return;
      }
      thumbs[nextIdx].click();
    }, { passive: true });
  }

  // ========== KALITE LOADER (tasarım overlay) ==========
  // Kullanıcı kalite veya desen tıkladığında "Tasarlanıyor..." overlay'i galeri
  // üzerinde beliriyor; arkada __reinitOzelOlcuConfig + amorf render çalışıyor.
  // Amorf render bitince veya 2s timeout'ta overlay kapanır.
  var _qlHideTimer = null;
  function installQualityLoader() {
    var gallery = document.querySelector('.bp-gallery__main');
    if (!gallery || gallery.querySelector('.bp-quality-loader')) return;
    var overlay = document.createElement('div');
    overlay.className = 'bp-quality-loader';
    overlay.innerHTML =
      '<div class="bp-ql-inner">' +
        '<svg class="bp-ql-svg" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid meet">' +
          '<circle class="bp-ql-ring" cx="50" cy="50" r="44" />' +
          '<path class="bp-ql-shape" d="" />' +
        '</svg>' +
        '<div class="bp-ql-text">Tasarlanıyor<span class="bp-ql-dots"><i></i><i></i><i></i></span></div>' +
        '<div class="bp-ql-sub">Halınız hazırlanıyor</div>' +
      '</div>';
    gallery.appendChild(overlay);
    // Amorf render tamamlandığında overlay'i kapat (custom event)
    window.addEventListener('amorf:render:complete', function() {
      hideQualityLoader();
    });
  }

  // Kullanıcının mevcut amorf radii'sinden SVG path üret (dinamik — sipariş şekliyle aynı).
  // Amorf değilse basit dairesel fallback (dikdörtgen/daire için).
  function _buildLoaderShapePath() {
    try {
      if (window.__OzelOlcuAmorf && window.__OzelOlcuAmorf.getShape) {
        var sh = window.__OzelOlcuAmorf.getShape();
        var radii = sh && sh.radii;
        if (radii && radii.length && Array.from(radii).some(function(r){ return r > 0.1; })) {
          var N = radii.length;
          var T = 0.28;
          var cx = 50, cy = 50, rx = 42, ry = 42;
          var pts = [];
          for (var i = 0; i < N; i++) {
            var a = (i / N) * Math.PI * 2 - Math.PI / 2;
            pts.push({ x: cx + Math.cos(a) * radii[i] * rx, y: cy + Math.sin(a) * radii[i] * ry });
          }
          var d = 'M' + pts[0].x.toFixed(1) + ',' + pts[0].y.toFixed(1);
          for (var j = 0; j < N; j++) {
            var p0 = pts[(j-1+N)%N], p1 = pts[j], p2 = pts[(j+1)%N], p3 = pts[(j+2)%N];
            d += ' C' + (p1.x + T*(p2.x-p0.x)).toFixed(1) + ',' + (p1.y + T*(p2.y-p0.y)).toFixed(1) +
                 ' ' + (p2.x - T*(p3.x-p1.x)).toFixed(1) + ',' + (p2.y - T*(p3.y-p1.y)).toFixed(1) +
                 ' ' + p2.x.toFixed(1) + ',' + p2.y.toFixed(1);
          }
          return d + 'Z';
        }
      }
    } catch(e) {}
    return ''; // amorf yok → sadece ring gösterilir
  }

  function showQualityLoader() {
    var ol = document.querySelector('.bp-quality-loader');
    if (!ol) return;
    // Kullanıcının mevcut amorf şekliyle path güncelle (dinamik, karıştırmaz)
    var pathEl = ol.querySelector('.bp-ql-shape');
    var path = _buildLoaderShapePath();
    if (pathEl) {
      pathEl.setAttribute('d', path);
      pathEl.style.display = path ? '' : 'none';
    }
    ol.classList.add('bp-ql-active');
    // Güvenlik: 2.5s içinde render bitmezse kapat
    if (_qlHideTimer) clearTimeout(_qlHideTimer);
    _qlHideTimer = setTimeout(hideQualityLoader, 2500);
  }
  function hideQualityLoader() {
    var ol = document.querySelector('.bp-quality-loader');
    if (!ol) return;
    ol.classList.remove('bp-ql-active');
    if (_qlHideTimer) { clearTimeout(_qlHideTimer); _qlHideTimer = null; }
  }

  // ========== KALİTE DEĞİŞİMİ ==========
  // ========== KALİTE NAVIGATE (URL geçişi + state koruma) ==========
  function navigateToQuality(qk) {
    var group = qualityGroups[qk];
    if (!group || !group.products || group.products.length === 0) return;

    // Mevcut state oku
    var wEl = document.getElementById('ozel-olcu-width');
    var lEl = document.getElementById('ozel-olcu-length');
    var shEl = document.getElementById('ozel-olcu-shape');
    var edgeInput = document.querySelector('input[name="ozel-olcu-edge"]:checked');

    var currentW = wEl ? (wEl.value || '') : '';
    var currentL = lEl ? (lEl.value || '') : '';
    var currentShape = (shEl ? shEl.value : '') || 'dikdortgen';
    var currentEdge = edgeInput ? edgeInput.value : 'biye';

    // Yeni kalitenin ilk ürünü
    var firstProduct = (allConfigs.products || {})[group.products[0].key];
    if (!firstProduct) return;
    var newEdgeTypes = firstProduct.edgeTypes || {};

    var biyeAllowed = normalizeQualityKey(firstProduct.qualityCode || '') === 'paradiso-plus';

    // Biye yalnizca Paradiso Plus'ta acik. Kalite gecisinde eski Biye state'i
    // hedef kaliteye tasinmaz; gecerli bir uretim kenarina guvenle duser.
    var currentEdgeAllowed = !!newEdgeTypes[currentEdge] && (currentEdge !== 'biye' || biyeAllowed);
    var prefersSacak = normalizeQualityKey(firstProduct.qualityCode || '') !== 'tokyo';
    var targetEdge = currentEdgeAllowed ? currentEdge
      : (prefersSacak && newEdgeTypes.sacak ? 'sacak'
        : (newEdgeTypes.overlok ? 'overlok'
          : (newEdgeTypes.sacak ? 'sacak'
          : (newEdgeTypes.bordur ? 'bordur'
            : (biyeAllowed && newEdgeTypes.biye ? 'biye' : '')))));
    if (!targetEdge) return;

    // Handle al
    var handles = firstProduct.shopifyHandles || {};
    var targetHandle = handles[targetEdge] || handles.overlok || handles.sacak || handles.bordur || (biyeAllowed ? handles.biye : '') || '';
    if (!targetHandle) return;

    // Amorf radii'yi localStorage'a kaydet
    if (currentShape === 'amorf' && window.__OzelOlcuAmorf && window.__OzelOlcuAmorf.getShape) {
      try {
        var sd = window.__OzelOlcuAmorf.getShape();
        if (sd && sd.radii && sd.radii.length > 0) {
          localStorage.setItem('ozel_olcu_banner_config', JSON.stringify({
            shape: 'amorf', edgeType: targetEdge,
            radii: Array.prototype.slice.call(sd.radii),
            ts: Date.now(), source: 'quality-tab'
          }));
        }
      } catch(_e) {}
    }

    // URL params ile navigate
    var params = [];
    if (currentW && parseInt(currentW) > 0) params.push('_ow=' + encodeURIComponent(currentW));
    if (currentL && parseInt(currentL) > 0) params.push('_oh=' + encodeURIComponent(currentL));
    if (currentShape && currentShape !== 'dikdortgen') params.push('_shape=' + encodeURIComponent(currentShape));
    params.push('_edge=' + encodeURIComponent(targetEdge));

    var navUrl = '/products/' + targetHandle + (params.length ? '?' + params.join('&') : '');
    console.log('[BannerProduct] Quality navigate:', qk, '->', navUrl);
    window.location.href = navUrl;
  }

  function setQuality(qualityKey) {
    if (!qualityGroups[qualityKey]) return;
    showQualityLoader();
    currentQualityKey = qualityKey;

    // Tab aktifliğini güncelle
    var tabs = elQualityTabs.querySelectorAll('.bp-qtab');
    for (var i = 0; i < tabs.length; i++) {
      if (tabs[i].getAttribute('data-quality') === qualityKey) {
        tabs[i].classList.add('active');
        tabs[i].setAttribute('aria-selected', 'true');
      } else {
        tabs[i].classList.remove('active');
        tabs[i].setAttribute('aria-selected', 'false');
      }
    }
    requestAnimationFrame(function() { centerActiveQualityTab('smooth'); });

    // Desenleri render et
    renderPatterns(qualityKey);

    // İlk deseni otomatik seç
    var group = qualityGroups[qualityKey];
    if (group.products.length > 0) {
      setPattern(group.products[0].key);
    }

    // Benzer ürünleri güncelle
    renderRelated(qualityKey);
  }

  // ========== DESEN RENDER ==========
  function renderPatterns(qualityKey) {
    if (!elPatterns) return;
    var group = qualityGroups[qualityKey];
    if (!group) { elPatterns.innerHTML = ''; return; }

    var html = '';
    for (var i = 0; i < group.products.length; i++) {
      var p = group.products[i];
      var isActive = (p.key === currentProductKey) ? ' active' : '';

      if (p.patternImage) {
        html += '<div class="bp-pat' + isActive + '" data-key="' + p.key + '" title="' + escapeHtml(p.patternCode) + '">';
        // FIX (desen gorsel iyilestirme): kart boyutlari 52->64/72 olunca
        // width=120 retina'da yumusak kaliyor. width=200'e cikardik: src=
        // aynen CDN URL, sadece width parametresi degisti; aspect ratio
        // (object-fit: cover) ve kaynak bozulmadi — kalite yukseliyor, dusmedi.
        html += '<img src="' + p.patternImage.replace('width=800', 'width=200') + '" alt="' + escapeHtml(p.patternCode) + '" loading="lazy" decoding="async" fetchpriority="low" />';
        html += '</div>';
      } else {
        html += '<div class="bp-pat' + isActive + '" data-key="' + p.key + '" title="' + escapeHtml(p.patternCode) + '"';
        if (p.patternBg) html += ' style="background:' + p.patternBg + '"';
        html += '></div>';
      }
    }
    elPatterns.innerHTML = html;

    // Event delegation — pattern tıklama
    elPatterns.onclick = function(e) {
      var pat = e.target.closest('.bp-pat');
      if (!pat) return;
      var key = pat.getAttribute('data-key');
      if (key && key !== currentProductKey) {
        setPattern(key);
      }
    };
  }

  function highlightCurrentPattern() {
    if (!elPatterns) return;
    var pats = elPatterns.querySelectorAll('.bp-pat');
    for (var i = 0; i < pats.length; i++) {
      if (pats[i].getAttribute('data-key') === currentProductKey) {
        pats[i].classList.add('active');
      } else {
        pats[i].classList.remove('active');
      }
    }
    // Desen ismi guncelle (init + degisim)
    var _curCfg = (allConfigs.products || {})[currentProductKey];
    var _dnEl = document.getElementById('bp-desen-name');
    if (_dnEl && _curCfg) _dnEl.textContent = _curCfg.patternCode ? '\u00b7 ' + _curCfg.patternCode : '';
  }

  // Macaron, Sumatra ve benzeri kalitelerde tum kenar tipleri ayni Shopify
  // urununu kullanir. Sayfa icinde desen degistiginde config ve galeri hemen
  // degisir; URL eski desende kalirsa sonraki kenar tiklamasi gereksiz bir
  // yonlendirme tetikler. Yalnizca tek handle'li configlerde URL'yi sessizce
  // aktif desenle esitle. Ayri kenar urunleri olan kalitelerin navigasyonuna
  // dokunma.
  function getSingleProductHandle(config) {
    var handles = (config && config.shopifyHandles) || {};
    var values = [];
    ['biye', 'overlok', 'bordur', 'sacak'].forEach(function(edgeKey) {
      var handle = handles[edgeKey];
      if (handle && values.indexOf(handle) === -1) values.push(handle);
    });
    return values.length === 1 ? values[0] : '';
  }

  function syncSingleHandlePatternUrl(config) {
    var targetHandle = getSingleProductHandle(config);
    if (!targetHandle || !window.history || !window.history.replaceState) return;

    var currentHandle = (window.location.pathname.split('/products/')[1] || '').split('?')[0];
    try { currentHandle = decodeURIComponent(currentHandle); } catch(_decodeError) {}

    var banner = document.getElementById('banner-product');
    var container = document.getElementById('ozel-olcu-plus');
    if (banner) banner.setAttribute('data-product-handle', targetHandle);
    if (container) container.setAttribute('data-product-handle', targetHandle);

    if (currentHandle === targetHandle) return;
    var nextUrl = '/products/' + targetHandle + window.location.search + window.location.hash;
    window.history.replaceState(window.history.state || {}, '', nextUrl);
    console.log('[BannerProduct] Single-handle URL sync:', targetHandle);
  }

  // ========== DESEN DEĞİŞİMİ ==========
  function setPattern(productKey) {
    var newCfg = (allConfigs.products || {})[productKey];
    if (!newCfg) return;
    // Ilk sayfa eski bir alias urun olabilir. Kullanici desen degistirip bu
    // kayda geri donerse artik canonical handle/varyant secilir; eski sayfanin
    // varyant metadata'si yeni desen akimina tasinmaz.
    if (newCfg.__resolvedByAlias) {
      newCfg = Object.assign({}, newCfg);
      delete newCfg.__resolvedByAlias;
      delete newCfg.__resolvedPageHandle;
      delete newCfg.__resolvedPageProductId;
      delete newCfg.__resolvedPageVariantId;
      allConfigs.products[productKey] = newCfg;
    }

    showQualityLoader();
    var oldKey = currentProductKey;
    currentProductKey = productKey;

    // Desen karesi aktifliği
    highlightCurrentPattern();

    // Başlık ve desen kodu güncelle
    if (elPatCode) {
      elPatCode.textContent = newCfg.patternCode || '';
    }
    // Desen başlığında isim göster
    var _desenName = document.getElementById('bp-desen-name');
    if (_desenName) _desenName.textContent = newCfg.patternCode ? '· ' + newCfg.patternCode : '';

    // Config switch — ozel-olcu-plus.js'i güncelle
    switchConfig(newCfg);
    currentConfig = newCfg;
    syncSingleHandlePatternUrl(newCfg);

    // Galeri görsellerini güncelle
    if (oldKey !== productKey) {
      updateGallery(newCfg);
    }

    // Canlı önizleme badge
    if (elLiveBadge) elLiveBadge.style.display = 'none';
  }

  // ========== CONFIG SWITCH ==========
  function switchConfig(newCfg) {
    // ozel-olcu-plus.js'in reinitConfig fonksiyonunu çağır
    if (typeof window.__reinitOzelOlcuConfig === 'function') {
      window.__reinitOzelOlcuConfig(newCfg);
    }

    // Container data attribute'larını güncelle
    var container = document.getElementById('ozel-olcu-plus');
    if (container && newCfg.shopifyHandles) {
      var handle = newCfg.shopifyHandles.biye || newCfg.shopifyHandles.overlok || '';
      container.setAttribute('data-product-handle', handle);
    }

    // Edge type gizleme/gösterme — config'e göre
    var edgeTypes = newCfg.edgeTypes || {};
    var biyeAllowed = normalizeQualityKey(newCfg.qualityCode || '') === 'paradiso-plus';
    if (container) container.setAttribute('data-biye-allowed', biyeAllowed ? 'true' : 'false');
    var edgeBtns = document.querySelectorAll('[data-edge]');
    for (var i = 0; i < edgeBtns.length; i++) {
      var edge = edgeBtns[i].getAttribute('data-edge');
      var allowed = !!edgeTypes[edge] && (edge !== 'biye' || biyeAllowed);
      edgeBtns[i].style.display = allowed ? '' : 'none';
      edgeBtns[i].setAttribute('data-edge-allowed', allowed ? 'true' : 'false');
    }

    // İlk görünür edge'i seç (eğer seçili olan gizlendiyse)
    var selectedEdgeEl = document.querySelector('.ozel-olcu-plus__radio.active');
    if (selectedEdgeEl && selectedEdgeEl.style.display === 'none') {
      for (var j = 0; j < edgeBtns.length; j++) {
        if (edgeBtns[j].style.display !== 'none') {
          var input = edgeBtns[j].querySelector('input[type="radio"]');
          if (input) {
            input.checked = true;
            input.dispatchEvent(new Event('change', { bubbles: true }));
          }
          break;
        }
      }
    }
    // FIX_SHAPE_RESET kaldırıldı — kalite geçişi artık navigasyon yapar, state URL'de taşınır.
  }

  // ========== GALERİ GÜNCELLEME ==========
  function updateGallery(config) {
    var handle = (config.shopifyHandles || {}).biye
      || (config.shopifyHandles || {}).overlok
      || '';

    if (!handle) return;

    // Loading göster
    if (elMainImage) elMainImage.style.opacity = '0.5';

    fetch('/products/' + handle + '.json')
      .then(function(res) {
        if (!res.ok) throw new Error('Ürün bulunamadı: ' + handle);
        return res.json();
      })
      .then(function(data) {
        var product = data.product;
        if (!product || !product.images || product.images.length === 0) return;

        // Ana görsel güncelle
        var firstImg = product.images[0].src;
        var _newSrc = firstImg.split('?')[0] + '?width=1200';
        // v5.4: Amorf modunda bp-product-img.src'yi OVERWRITE ETME — eski amorf data:url
        // ekranda kalsin ki kullanici flicker (dikdortgen) gormesin. doUpdate
        // data-original-src'den yeni URL'yi okuyup amorf'u render edecek.
        var _isAmorfNow_g = !!(window.__OzelOlcuAmorf && window.__OzelOlcuAmorf.isAmorf && window.__OzelOlcuAmorf.isAmorf());
        if (elMainImage) {
          elMainImage.setAttribute('data-zoom-src', firstImg.split('?')[0] + '?width=2400');
          elMainImage.setAttribute('data-original-src', _newSrc);
          if (!_isAmorfNow_g) {
            elMainImage.src = _newSrc;
          }
          elMainImage.style.opacity = '1';
        }

        // Thumbnail'leri güncelle
        if (elThumbs) {
          var thumbHtml = '';
          for (var i = 0; i < product.images.length; i++) {
            var img = product.images[i];
            var isFirst = (i === 0) ? ' active' : '';
            thumbHtml += '<div class="bp-thumb' + isFirst + '"'
              + ' data-index="' + i + '"'
              + ' data-src="' + img.src.split('?')[0] + '?width=1200"'
              + ' data-zoom="' + img.src.split('?')[0] + '?width=2400"'
              + ' data-original="' + img.src.split('?')[0] + '?width=1200">'
              + '<img src="' + img.src.split('?')[0] + '?width=120" alt="" loading="lazy" decoding="async" fetchpriority="low" width="60" height="60" />'
              + '</div>';
          }
          elThumbs.innerHTML = thumbHtml;
        }

        // Başlık güncelle
        if (elTitle && product.title) {
          elTitle.textContent = product.title;
        }

        // Preview motoru yeniden başlat
        if (window.__ozelOlcuPreview && window.__ozelOlcuPreview.setProductImage) {
          window.__ozelOlcuPreview.setProductImage(firstImg.split('?')[0] + '?width=1200');
        }

        // Amorf aktifse: yeni galeride amorf rendering'i GARANTI ALTINA AL.
        // ESKI BUG (v5.1): Sabit 800ms+500ms gecikme kullanildigi icin yavas yuklenen
        // urun gorseli/kumas durumunda amorf re-render BASARISIZ olup dikdortgen kaliyordu.
        // YENI (v5.2): Polling tabanli — fabric aktif + bp-product-img CDN URL'si ile
        // tam yuklenmis olana kadar bekler, sonra amorfForceUpdate cagirir + 800ms sonra
        // dogrulama yapar (data:url'a donmemisse tekrar dener). 6sn cap, 16 deneme max.
        var _shSel = document.getElementById('ozel-olcu-shape');
        var _isAmorfNow = _shSel && (_shSel.value === 'amorf' || _shSel.value === 'daire' || _shSel.value === 'oval');
        if (_isAmorfNow) {
          if (window.__resetAmorfOriginals) window.__resetAmorfOriginals();

          var _amorfAttempt = 0;
          var _amorfMaxAttempts = 16;
          var _amorfRetry = function() {
            _amorfAttempt++;
            // Kumas aktif degilse otomatik ilk kumasi sec
            if (!document.querySelector('.ozel-olcu-plus__color-btn.active')) {
              var _firstFab = document.querySelector('.ozel-olcu-plus__color-btn');
              if (_firstFab) _firstFab.click();
            }
            var _bpImg = document.getElementById('bp-product-img');
            var _hasFab = !!document.querySelector('.ozel-olcu-plus__color-btn.active');
            // v5.3: Sadece CDN URL'si SET edilmis olmasi yeterli (data: degil).
            // doUpdate kendi icinde Image() ile yuklemeyi yapiyor — naturalWidth/complete
            // beklemek gereksiz (lazy-load yavas Monza gibi durumlarda timeout'a yol aciyor).
            var _bpSrc = _bpImg && (_bpImg.getAttribute('data-original-src') || _bpImg.src) || '';
            var _imgReady = _bpSrc && _bpSrc.indexOf('data:') !== 0 && _bpSrc.length > 10;
            if (_imgReady && _hasFab) {
              if (window.__amorfForceUpdate) {
                console.log('[BannerProduct] Amorf FORCE re-render (attempt ' + _amorfAttempt + ')');
                window.__amorfForceUpdate();
              } else if (window.__amorfGaleriGuncelle) {
                window.__amorfGaleriGuncelle();
              }
              // Dogrulama: 1sn sonra bp-product-img amorf data:url'a donmediyse tekrar dene
              setTimeout(function() {
                var _bp2 = document.getElementById('bp-product-img');
                var _shCheck = document.getElementById('ozel-olcu-shape');
                var _stillAmorf = _shCheck && (_shCheck.value === 'amorf' || _shCheck.value === 'daire' || _shCheck.value === 'oval');
                if (_stillAmorf && _bp2 && (_bp2.src || '').indexOf('data:') !== 0 && _amorfAttempt < _amorfMaxAttempts) {
                  console.warn('[BannerProduct] Amorf data:url uygulanmamis, retry');
                  _amorfRetry();
                }
              }, 1000);
              return;
            }
            if (_amorfAttempt < _amorfMaxAttempts) setTimeout(_amorfRetry, 350);
            else console.warn('[BannerProduct] Amorf re-render polling timeout (img/fabric hazir degil)');
          };
          setTimeout(_amorfRetry, 350);
        }

        // Variant ID güncelle (container data attribute)
        if (product.variants && product.variants.length > 0) {
          var container = document.getElementById('ozel-olcu-plus');
          if (container) {
            container.setAttribute('data-variant-id', product.variants[0].id);
          }
        }

        console.log('[BannerProduct] Galeri güncellendi:', handle, product.images.length, 'görsel');
      })
      .catch(function(err) {
        console.error('[BannerProduct] Galeri güncelleme hatası:', err);
        if (elMainImage) elMainImage.style.opacity = '1';
      });
  }

  // ========== GALERİ THUMBNAIL ==========
  function initGalleryThumbs() {
    if (!elThumbs) return;

    // Event delegation — thumbnail tıklama
    elThumbs.addEventListener('click', function(e) {
      var thumb = e.target.closest('.bp-thumb');
      if (!thumb) return;

      var src = thumb.getAttribute('data-src');
      var zoomSrc = thumb.getAttribute('data-zoom');

      if (!src || !elMainImage) return;

      // Aktif thumbnail güncelle
      var allThumbs = elThumbs.querySelectorAll('.bp-thumb');
      for (var i = 0; i < allThumbs.length; i++) {
        allThumbs[i].classList.remove('active');
      }
      thumb.classList.add('active');

      // Ana görsel güncelle
      var thumbIdx = parseInt(thumb.getAttribute('data-index') || '0');
      // Video player kontrolü
      var mediaType = thumb.getAttribute('data-media-type') || 'image';
      var videoPlayer = document.getElementById('bp-video-player');
      var videoEl = document.getElementById('bp-video-el');
      if (mediaType === 'video' || mediaType === 'external_video') {
        // Video göster
        if (videoPlayer && videoEl) {
          var videoUrl = thumb.getAttribute('data-video-url');
          if (videoUrl) {
            videoEl.src = videoUrl;
            videoPlayer.classList.add('bp-video-active');
            elMainImage.style.display = 'none';
            videoEl.play().catch(function(){});
          }
        }
      } else {
        // Image göster, video gizle
        if (videoPlayer) { videoPlayer.classList.remove('bp-video-active'); if (videoEl) { videoEl.pause(); videoEl.src = ''; } }
        if (elMainImage) elMainImage.style.display = '';
      }

      // Amorf overlay/hotspot sadece 1. resimde gorunsun
      var _amorfOv = document.getElementById('bp-amorf-dim-overlay');
      var _presetBg = document.getElementById('bp-preset-badge');
      var _hsEdge = document.getElementById('bp-hs-edge');
      if (thumbIdx === 0) {
        if (_amorfOv) _amorfOv.style.display = '';
        if (_presetBg) _presetBg.style.display = '';
        if (_hsEdge) _hsEdge.style.display = '';
        document.querySelectorAll('.bp-ruler').forEach(function(r){r.style.display='';});
      } else {
        if (_amorfOv) _amorfOv.style.display = 'none';
        if (_presetBg) _presetBg.style.display = 'none';
        if (_hsEdge) _hsEdge.style.display = 'none';
        document.querySelectorAll('.bp-ruler').forEach(function(r){r.style.display='none';});
      }
      if (thumbIdx === 0 && window.__amorfActive && window._amorfCurrentDataUrl) {
        // Amorf aktif ve 1. görsele dönüyor — amorf giydirmeyi geri yükle
        elMainImage.src = window._amorfCurrentDataUrl;
        elMainImage.setAttribute('data-zoom-src', window._amorfCurrentDataUrl);
        elMainImage.setAttribute('data-original-src', src);
      } else {
        elMainImage.src = src;
        if (zoomSrc) {
          elMainImage.setAttribute('data-zoom-src', zoomSrc);
        }
        elMainImage.setAttribute('data-original-src', src);
      }
    });
  }

  // ========== ZOOM ==========
  function initZoom() {
    if (!elZoomBtn || !elMainImage) return;

    elZoomBtn.addEventListener('click', function() {
      // Giydirmeli preview (data:url) varsa onu goster, yoksa orijinal zoom
      var zoomSrc = (elMainImage.src && elMainImage.src.indexOf('data:') === 0)
        ? elMainImage.src
        : (elMainImage.getAttribute('data-zoom-src') || elMainImage.src);
      openLightbox(zoomSrc);
    });

    // Ana görsele tıklayınca da zoom
    elMainImage.addEventListener('click', function() {
      var zoomSrc = (elMainImage.src && elMainImage.src.indexOf('data:') === 0)
        ? elMainImage.src
        : (elMainImage.getAttribute('data-zoom-src') || elMainImage.src);
      openLightbox(zoomSrc);
    });
    elMainImage.style.cursor = 'zoom-in';
  }

  // ========== CETVEL / RULER ==========
  function createRulers() {
    var gallery = document.querySelector('.bp-gallery__main');
    if (!gallery || document.getElementById('bp-ruler-h')) return;

    // Ok tipleri (CSS triangle)
    var _rArrL = '<span style="flex-shrink:0;width:0;height:0;border-top:5px solid transparent;border-bottom:5px solid transparent;border-right:7px solid #333;"></span>';
    var _rArrR = '<span style="flex-shrink:0;width:0;height:0;border-top:5px solid transparent;border-bottom:5px solid transparent;border-left:7px solid #333;"></span>';
    var _rArrU = '<span style="flex-shrink:0;width:0;height:0;border-left:5px solid transparent;border-right:5px solid transparent;border-bottom:7px solid #333;"></span>';
    var _rArrD = '<span style="flex-shrink:0;width:0;height:0;border-left:5px solid transparent;border-right:5px solid transparent;border-top:7px solid #333;"></span>';

    // Yatay cetvel (en) — ALTTA, gallery genişliğinin %85'i, merkezli (amorf dim-h ile aynı hizada)
    var hRuler = document.createElement('div');
    hRuler.id = 'bp-ruler-h';
    hRuler.className = 'bp-ruler bp-ruler--h';
    hRuler.style.cssText = 'position:absolute;bottom:4px;left:50%;transform:translateX(-50%);width:85%;height:20px;display:flex;align-items:center;gap:3px;z-index:15;pointer-events:none;';
    hRuler.innerHTML =
      _rArrL +
      '<span style="flex:1;border-top:1.4px solid #333;"></span>' +
      '<span class="bp-ruler__label" id="bp-ruler-h-label" style="padding:2px 6px;font-size:11px;font-weight:600;color:#333;background:rgba(255,255,255,0.95);border-radius:3px;white-space:nowrap;pointer-events:auto;">100 cm</span>' +
      '<span style="flex:1;border-top:1.4px solid #333;"></span>' +
      _rArrR;

    // Dikey cetvel (boy) — SOLDA, gallery yüksek'inin %85'i, merkezli (amorf dim-v ile aynı hizada)
    var vRuler = document.createElement('div');
    vRuler.id = 'bp-ruler-v';
    vRuler.className = 'bp-ruler bp-ruler--v';
    vRuler.style.cssText = 'position:absolute;left:4px;top:50%;transform:translateY(-50%);height:85%;width:20px;display:flex;flex-direction:column;align-items:center;gap:3px;z-index:15;pointer-events:none;';
    vRuler.innerHTML =
      _rArrU +
      '<span style="flex:1;border-left:1.4px solid #333;"></span>' +
      '<span class="bp-ruler__label" id="bp-ruler-v-label" style="padding:4px 3px;font-size:11px;font-weight:600;color:#333;background:rgba(255,255,255,0.95);border-radius:3px;writing-mode:vertical-lr;transform:rotate(180deg);white-space:nowrap;pointer-events:auto;">200 cm</span>' +
      '<span style="flex:1;border-left:1.4px solid #333;"></span>' +
      _rArrD;

    gallery.style.paddingBottom = '28px';
    gallery.style.paddingLeft = '28px';

    gallery.appendChild(hRuler);
    gallery.appendChild(vRuler);

    // Ölçü değiştiğinde güncelle
    var wInput = document.getElementById('ozel-olcu-width');
    var hInput = document.getElementById('ozel-olcu-length');
    function updateLabels() {
      var hLabel = document.getElementById('bp-ruler-h-label');
      var vLabel = document.getElementById('bp-ruler-v-label');
      if (hLabel && wInput) hLabel.textContent = (wInput.value || '100') + ' cm';
      if (vLabel && hInput) vLabel.textContent = (hInput.value || '200') + ' cm';
    }
    if (wInput) wInput.addEventListener('input', updateLabels);
    if (hInput) hInput.addEventListener('input', updateLabels);
    updateLabels();
  }

  // Sayfa yüklendiğinde cetvelleri oluştur
  setTimeout(createRulers, 500);

  function openLightbox(src) {
    var existing = document.getElementById('bp-lightbox');
    if (existing) existing.remove();

    var isDataUrl = src && src.indexOf('data:') === 0;

    var overlay = document.createElement('div');
    overlay.id = 'bp-lightbox';
    overlay.style.cssText = 'position:fixed;inset:0;z-index:9999;background:rgba(245,245,245,0.97);display:flex;align-items:center;justify-content:center;overflow:auto;';

    var imgWrap = document.createElement('div');
    imgWrap.style.cssText = 'display:flex;align-items:center;justify-content:center;min-height:100%;padding:20px;';

    var img = document.createElement('img');
    img.src = src;
    img.alt = 'Zoom';
    img.style.cssText = 'max-width:90vw;max-height:90vh;object-fit:contain;cursor:zoom-in;transition:transform 0.25s ease;background:#fff;border-radius:8px;box-shadow:0 4px 30px rgba(0,0,0,0.15);';

    var closeBtn = document.createElement('button');
    closeBtn.style.cssText = 'position:fixed;top:16px;right:16px;width:40px;height:40px;background:rgba(0,0,0,0.08);border:none;border-radius:50%;color:#333;font-size:22px;cursor:pointer;display:flex;align-items:center;justify-content:center;z-index:10;';
    closeBtn.innerHTML = '\u00D7';
    closeBtn.addEventListener('click', function(e) { e.stopPropagation(); close(); });

    imgWrap.appendChild(img);
    overlay.appendChild(imgWrap);
    overlay.appendChild(closeBtn);
    document.body.appendChild(overlay);

    function close() { overlay.remove(); }
    overlay.addEventListener('click', function(e) {
      if (e.target === overlay || e.target === imgWrap) close();
    });
    document.addEventListener('keydown', function handler(e) {
      if (e.key === 'Escape') { close(); document.removeEventListener('keydown', handler); }
    });

    // Zoom + Pan sistemi
    var zoomLevels = [1, 1.5, 2.5];
    var zoomIdx = 0;
    var panX = 0, panY = 0;
    var isDragging = false, dragStartX = 0, dragStartY = 0, startPanX = 0, startPanY = 0;

    function applyTransform() {
      var z = zoomLevels[zoomIdx];
      if (z > 1) {
        img.style.transform = 'scale(' + z + ') translate(' + panX + 'px,' + panY + 'px)';
        img.style.cursor = isDragging ? 'grabbing' : 'grab';
        img.style.maxWidth = 'none';
        img.style.maxHeight = 'none';
        imgWrap.style.overflow = 'visible';
      } else {
        img.style.transform = '';
        img.style.cursor = 'zoom-in';
        img.style.maxWidth = '90vw';
        img.style.maxHeight = '90vh';
        panX = 0; panY = 0;
      }
    }

    // Zoom badge
    var zoomBadge = document.createElement('div');
    zoomBadge.style.cssText = 'position:fixed;bottom:20px;left:50%;transform:translateX(-50%);background:rgba(0,0,0,0.6);color:#fff;padding:6px 16px;border-radius:20px;font-size:13px;font-weight:600;z-index:10;pointer-events:none;transition:opacity 0.3s;opacity:0;';
    overlay.appendChild(zoomBadge);
    function showZoomBadge(text) {
      zoomBadge.textContent = text;
      zoomBadge.style.opacity = '1';
      clearTimeout(zoomBadge._t);
      zoomBadge._t = setTimeout(function() { zoomBadge.style.opacity = '0'; }, 1500);
    }

    // Click-to-zoom + double-click reset
    var lastClickTime = 0;
    var clickTimer = null;
    img.addEventListener('click', function(e) {
      e.stopPropagation();
      if (isDragging) return;
      var now = Date.now();
      if (now - lastClickTime < 100) return;
      // Double-click: aninda 1x'e don
      if (clickTimer) { clearTimeout(clickTimer); clickTimer = null; zoomIdx = 0; panX = 0; panY = 0; applyTransform(); showZoomBadge('1x'); return; }
      clickTimer = setTimeout(function() {
        clickTimer = null;
        zoomIdx = (zoomIdx + 1) % zoomLevels.length;
        if (zoomIdx === 0) { panX = 0; panY = 0; }
        var z = zoomLevels[zoomIdx];
        showZoomBadge(z === 1 ? '1x' : z + 'x \u2014 s\u00fcr\u00fckle');
        applyTransform();
      }, 250);
    });

    // Mouse drag-to-pan (5px+ hareket gerekli, yoksa click sayilir)
    var mouseDownActive = false;
    var didRealDrag = false;
    img.addEventListener('mousedown', function(e) {
      if (zoomLevels[zoomIdx] <= 1) return;
      e.preventDefault();
      mouseDownActive = true;
      didRealDrag = false;
      dragStartX = e.clientX; dragStartY = e.clientY;
      startPanX = panX; startPanY = panY;
    });
    window.addEventListener('mousemove', function(e) {
      if (!mouseDownActive) return;
      var dx = e.clientX - dragStartX, dy = e.clientY - dragStartY;
      if (!didRealDrag && Math.abs(dx) + Math.abs(dy) < 5) return;
      didRealDrag = true;
      isDragging = true;
      var z = zoomLevels[zoomIdx];
      panX = startPanX + dx / z;
      panY = startPanY + dy / z;
      img.style.cursor = 'grabbing';
      applyTransform();
    });
    window.addEventListener('mouseup', function() {
      if (!mouseDownActive) return;
      mouseDownActive = false;
      if (didRealDrag) { lastClickTime = Date.now(); }
      isDragging = false;
      didRealDrag = false;
      applyTransform();
    });

    // Mobil: tek parmak pan + cift parmak pinch-zoom
    var scale = 1;
    var lastDist = 0;
    var touchStartX = 0, touchStartY = 0, touchStartPanX = 0, touchStartPanY = 0;
    img.addEventListener('touchstart', function(e) {
      if (e.touches.length === 2) {
        lastDist = Math.hypot(e.touches[0].pageX - e.touches[1].pageX, e.touches[0].pageY - e.touches[1].pageY);
      } else if (e.touches.length === 1 && zoomLevels[zoomIdx] > 1) {
        touchStartX = e.touches[0].clientX; touchStartY = e.touches[0].clientY;
        touchStartPanX = panX; touchStartPanY = panY;
      }
    }, { passive: true });
    img.addEventListener('touchmove', function(e) {
      if (e.touches.length === 2) {
        var dist = Math.hypot(e.touches[0].pageX - e.touches[1].pageX, e.touches[0].pageY - e.touches[1].pageY);
        if (lastDist > 0) {
          scale = Math.max(0.5, Math.min(4, scale * (dist / lastDist)));
          img.style.transform = 'scale(' + scale + ')';
        }
        lastDist = dist;
      } else if (e.touches.length === 1 && zoomLevels[zoomIdx] > 1) {
        e.preventDefault();
        var z = zoomLevels[zoomIdx];
        panX = touchStartPanX + (e.touches[0].clientX - touchStartX) / z;
        panY = touchStartPanY + (e.touches[0].clientY - touchStartY) / z;
        applyTransform();
      }
    }, { passive: false });
  }

  // ========== TESLİMAT TİMELINE ==========
  function renderDeliveryTimeline() {
    if (!elDelivery) return;

    var now = new Date();
    var hour = now.getHours();

    // Sipariş tarihi
    var orderDate = new Date(now);

    // Kargo tarihi: bugün 15:00'dan önce → bugün, sonra → yarın
    var shipDate = new Date(now);
    if (hour >= 15) shipDate.setDate(shipDate.getDate() + 1);
    // Pazar atla
    if (shipDate.getDay() === 0) shipDate.setDate(shipDate.getDate() + 1);

    // Teslimat tarihi: kargo + 2 gün
    var delivDate = new Date(shipDate);
    delivDate.setDate(delivDate.getDate() + 2);
    if (delivDate.getDay() === 0) delivDate.setDate(delivDate.getDate() + 1);

    var gunler = ['Paz', 'Pzt', 'Sal', 'Çar', 'Per', 'Cum', 'Cmt'];

    function fmt(d) {
      return ('0' + d.getDate()).slice(-2) + '.' + ('0' + (d.getMonth() + 1)).slice(-2);
    }

    elDelivery.innerHTML =
      '<div class="bp-dlv-step"><div class="bp-dlv-dot done">1</div><span>Sipariş</span><small>' + fmt(orderDate) + ' ' + gunler[orderDate.getDay()] + '</small></div>' +
      '<div class="bp-dlv-step"><div class="bp-dlv-dot">2</div><span>Kargo</span><small>' + fmt(shipDate) + ' ' + gunler[shipDate.getDay()] + '</small></div>' +
      '<div class="bp-dlv-step"><div class="bp-dlv-dot">3</div><span>Teslim</span><small>' + fmt(delivDate) + ' ' + gunler[delivDate.getDay()] + '</small></div>';
  }

  // ========== BENZER ÜRÜNLER ==========
  function renderRelated(qualityKey) {
    if (!elRelated) return;
    var group = qualityGroups[qualityKey];
    if (!group || group.products.length <= 1) {
      elRelated.innerHTML = '';
      return;
    }

    var html = '<div class="bp-related-title">Aynı koleksiyon</div><div class="bp-related-list">';
    for (var i = 0; i < group.products.length; i++) {
      var p = group.products[i];
      if (p.key === currentProductKey) continue;

      var cfg = (allConfigs.products || {})[p.key] || {};
      var price = cfg.m2Price ? (cfg.m2Price + ' TL/m²') : '';

      html += '<div class="bp-rel-card" data-key="' + p.key + '">';
      html += '<div class="bp-rel-img">';
      if (p.patternImage) {
        html += '<img src="' + p.patternImage.replace('width=800', 'width=200') + '" alt="' + escapeHtml(p.patternCode) + '" loading="lazy" decoding="async" fetchpriority="low" />';
      }
      html += '</div>';
      html += '<div class="bp-rel-name">' + escapeHtml(p.patternCode) + '</div>';
      if (price) html += '<div class="bp-rel-price">' + price + '</div>';
      html += '</div>';
    }
    html += '</div>';
    elRelated.innerHTML = html;

    // Tıklama — desen değiştir
    elRelated.onclick = function(e) {
      var card = e.target.closest('.bp-rel-card');
      if (!card) return;
      var key = card.getAttribute('data-key');
      if (key) setPattern(key);
    };
  }



  // ========== COMPLEMENTARY PRODUCTS (Diğer Şekil Seçenekleri) ==========
  function loadComplementary() {
    var el = document.getElementById('bp-complementary');
    if (!el) return;

    var productId = document.getElementById('banner-product')
      ? document.getElementById('banner-product').getAttribute('data-product-id')
      : '';
    if (!productId) return;

    fetch('/recommendations/products.json?product_id=' + productId + '&intent=complementary&limit=6')
      .then(function(res) { return res.ok ? res.json() : null; })
      .then(function(data) {
        if (!data || !data.products || data.products.length === 0) {
          el.style.display = 'none';
          return;
        }

        var html = '<div class="bp-related-title">Diğer Şekil Seçenekleri</div>';
        html += '<div class="bp-related-list">';
        for (var i = 0; i < data.products.length; i++) {
          var p = data.products[i];
          var img = (p.featured_image) ? p.featured_image.replace(/\.jpg|.png|.webp/, function(m) { return m; }).split('?')[0] + '?width=200' : '';
          var price = p.price ? (p.price / 100).toLocaleString('tr-TR') + ' TL' : '';

          html += '<a href="' + p.url + '" class="bp-rel-card" style="text-decoration:none;color:inherit;">';
          html += '<div class="bp-rel-img">';
          if (img) html += '<img src="' + img + '" alt="' + escapeHtml(p.title) + '" loading="lazy" decoding="async" fetchpriority="low" />';
          html += '</div>';
          html += '<div class="bp-rel-name">' + escapeHtml(p.title.replace(/Dolce Vita Hal[ıi]s*/i, '')) + '</div>';
          if (price) html += '<div class="bp-rel-price">' + price + '</div>';
          html += '</a>';
        }
        html += '</div>';
        el.innerHTML = html;
      })
      .catch(function(err) {
        console.warn('[BannerProduct] Complementary yüklenemedi:', err);
        el.style.display = 'none';
      });
  }

  // ========== KUMAŞ SEÇİMİNDE CANLI ÖNİZLEME BADGE ==========
  function watchFabricSelection() {
    var colorOptions = document.getElementById('ozel-olcu-color-options');
    if (!colorOptions) return;

    var observer = new MutationObserver(function() {
      // Kumaş seçilince canlı önizleme badge göster
      var selected = colorOptions.querySelector('.selected, .active');
      if (selected && elLiveBadge) {
        elLiveBadge.style.display = '';
      }
    });
    observer.observe(colorOptions, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
  }

  // ========== YARDIMCI ==========
  function escapeHtml(str) {
    if (!str) return '';
    return str.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  // ========== BAŞLAT ==========
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      // Motorların yüklenmesini bekle
      setTimeout(init, 300);
      setTimeout(watchFabricSelection, 1500);
    setTimeout(reorderTrustSection, 800);
    });
  } else {
    setTimeout(init, 300);
    setTimeout(watchFabricSelection, 1500);
    setTimeout(reorderTrustSection, 800);
  }

  // Sıralama: Timeline → Paylaş → Güvenli Ödeme

  // -- FIYAT SLOTU + SLIDER -- variant:change ile guncelle + kaydirma cubugu
  (function() {
    var slot = document.getElementById('bp-price-slot');

    // === FiYAT FORMAT ===
    function fmtTL(n) {
      return new Intl.NumberFormat('tr-TR', {minimumFractionDigits: 2, maximumFractionDigits: 2}).format(n);
    }

    // === FIYAT SLOT RENDER ===
    function renderPriceSlot(price, comparePrice, variantTitle) {
      if (!slot) return;
      var hasDiscount = comparePrice > price;
      var pct = hasDiscount ? Math.round((1 - price / comparePrice) * 100) : 0;
      var savings = hasDiscount ? fmtTL(comparePrice - price) : 0;
      var inst6 = fmtTL(price / 6);
      var pesin = fmtTL(price);
      var sizeHint = (variantTitle && variantTitle !== 'Default Title') ? variantTitle + ' i\u00E7in ' : '';
      var h = '';
      if (hasDiscount) h += '<div class="bps-discount-badge">%' + pct + ' \u0130ND\u0130R\u0130M &bull; ' + savings + ' TL TASARRUF</div>';
      h += '<div class="bps-taksit-row">&#128179; ' + sizeHint + '6 TAKS\u0130T, pe\u015fin fiyat\u0131na ' + pesin + ' TL</div>';
      h += '<div class="bps-monthly-row"><span class="bps-monthly-amount">' + inst6 + ' TL</span><span class="bps-monthly-term">&nbsp;x 6 AY</span></div>';
      slot.innerHTML = h;
    }

    function renderDolceVitaPricePrompt() {
      if (!slot) return;
      slot.innerHTML = '<div class="bps-placeholder">&#128179; Ölçülerinizi girerek fiyatı hesaplayın</div>';
    }

    document.addEventListener('variant:change', function(e) {
      if (!e.detail || !e.detail.variant) return;
      var v = e.detail.variant;
      var price   = (v.price || 0) / 100;
      var compare = (v.compare_at_price || v.price || 0) / 100;
      var title   = v.title || v.name || '';
      var dvRoot = document.querySelector('#banner-product[data-configurator-brand="dolce-vita"]');
      if (dvRoot) {
        var dvWidth = document.getElementById('ozel-olcu-width');
        var dvLength = document.getElementById('ozel-olcu-length');
        if (!parseInt(dvWidth && dvWidth.value, 10) ||
            !parseInt(dvLength && dvLength.value, 10) ||
            title === 'Default Title') {
          renderDolceVitaPricePrompt();
          return;
        }
      }
      if (price > 0) renderPriceSlot(price, compare, title);
    });

    var dvPriceRoot = document.querySelector('#banner-product[data-configurator-brand="dolce-vita"]');
    if (dvPriceRoot) {
      var dvPriceWidth = document.getElementById('ozel-olcu-width');
      var dvPriceLength = document.getElementById('ozel-olcu-length');
      [dvPriceWidth, dvPriceLength].forEach(function(input) {
        if (!input) return;
        input.addEventListener('input', function() {
          if (!parseInt(dvPriceWidth && dvPriceWidth.value, 10) ||
              !parseInt(dvPriceLength && dvPriceLength.value, 10)) {
            renderDolceVitaPricePrompt();
          }
        });
      });
      if (!parseInt(dvPriceWidth && dvPriceWidth.value, 10) ||
          !parseInt(dvPriceLength && dvPriceLength.value, 10)) {
        renderDolceVitaPricePrompt();
      }
    }

    // === SLIDER SISTEMI ===
    function initSliders() {
      var wNum   = document.getElementById('ozel-olcu-width');
      var lNum   = document.getElementById('ozel-olcu-length');
      var wRange = document.getElementById('bp-range-width');
      var lRange = document.getElementById('bp-range-length');

      if (!wNum || !lNum || !wRange || !lRange) return;

      // Track rengi guncelleyici
      function updateTrack(range) {
        var min = parseFloat(range.min) || 50;
        var max = parseFloat(range.max) || 200;
        var val = parseFloat(range.value) || min;
        var pct = ((val - min) / (max - min) * 100).toFixed(1) + '%';
        range.style.setProperty('--pct', pct);
      }

      // Sayisal input -> slider sync
      function syncNumToRange(numEl, rangeEl) {
        var v = parseInt(numEl.value);
        if (!isNaN(v) && v >= parseInt(rangeEl.min) && v <= parseInt(rangeEl.max)) {
          rangeEl.value = v;
          updateTrack(rangeEl);
        }
      }

      // Slider -> sayisal input sync
      function syncRangeToNum(rangeEl, numEl) {
        numEl.value = rangeEl.value;
        numEl.classList.remove('bp-showing-default');
        updateTrack(rangeEl);
        numEl.dispatchEvent(new Event('input', { bubbles: true }));
      }

      // EN (width) slider
      wRange.addEventListener('input', function() {
        syncRangeToNum(wRange, wNum);
      });

      // BOY (length) slider
      lRange.addEventListener('input', function() {
        syncRangeToNum(lRange, lNum);
      });

      // Sayisal input -> slider (FIX 2026-05-11: isTrusted — programatik event'leri sayma)
      wNum.addEventListener('input', function(e) {
        if (e.isTrusted) wNum.classList.remove('bp-showing-default');
        syncNumToRange(wNum, wRange);
      });
      lNum.addEventListener('input', function(e) {
        if (e.isTrusted) lNum.classList.remove('bp-showing-default');
        syncNumToRange(lNum, lRange);
      });

      // Focus: silik default ise VALUE SIL + class kaldir (FIX 2026-05-11)
      [wNum, lNum].forEach(function(el) {
        el.addEventListener('focus', function() {
          if (this.classList.contains('bp-showing-default')) {
            this.value = '';
            this.classList.remove('bp-showing-default');
          }
        });
      });

      // Track renklerini baslat
      updateTrack(wRange);
      updateTrack(lRange);

      // ozel-olcu-plus.js kendi snap'ini yapinca: snapped width'i range'e yansi
      // (ozel-olcu-width-info guncellenince slot'un snap yansimasi icin)
      var wInfoEl = document.getElementById('ozel-olcu-width-info');
      if (wInfoEl) {
        var wInfoObs = new MutationObserver(function() {
          var v = parseInt(wNum.value);
          if (!isNaN(v) && v >= 50 && v <= 200) { wRange.value = v; updateTrack(wRange); }
        });
        wInfoObs.observe(wInfoEl, { childList: true, subtree: true, characterData: true });
      }
    }

    // === DEFAULT 80x100 TETIKLEME ===
    function triggerDefaultCalc() {
      var dvRoot = document.querySelector('#banner-product[data-configurator-brand="dolce-vita"]');
      if (dvRoot) return;
      var wEl = document.getElementById('ozel-olcu-width');
      var lEl = document.getElementById('ozel-olcu-length');
      var wRange = document.getElementById('bp-range-width');
      var lRange = document.getElementById('bp-range-length');
      if (!wEl || !lEl) return;
      if (wEl.dataset.userEdited || lEl.dataset.userEdited) return;

      var needsWidth = !wEl.value;
      var needsLength = !lEl.value;
      // HTML varsayilanlari veya URL/session geri yuklemesi hazirsa motorun
      // kendi tek hesaplamasini kullan; ayni stok istegini ikinci kez baslatma.
      if (!needsWidth && !needsLength) return;

      if (needsWidth) {
        wEl.value = '80';
        wEl.classList.add('bp-showing-default');
        if (wRange) { wRange.value = '80'; wRange.style.setProperty('--pct', '15%'); }
      }

      if (needsLength) {
        lEl.value = '100';
        lEl.classList.add('bp-showing-default');
        if (lRange) { lRange.value = '100'; lRange.style.setProperty('--pct', '9.1%'); }
      }

      // Iki deger de hazirken yalnizca bir hesaplama olayi tetikle.
      (needsLength ? lEl : wEl).dispatchEvent(new Event('input', { bubbles: true }));
    }

    // FIX 2026-05-11: Default silik gosterilen "80"/"100" input'u tiklayinca/focus alinca temizle
    function setupDefaultClearOnFocus() {
      var wEl = document.getElementById('ozel-olcu-width');
      var lEl = document.getElementById('ozel-olcu-length');
      var dvRoot = document.querySelector('#banner-product[data-configurator-brand="dolce-vita"]');
      function setupOne(el) {
        if (!el || el._defaultClearBound) return;
        el._defaultClearBound = true;
        el.addEventListener('focus', function() {
          if (el.classList.contains('bp-showing-default')) {
            el.value = '';
            el.classList.remove('bp-showing-default');
            el.dataset.userEdited = '1';
            // input event tetikleme — yoksa banner fiyat NaN gosterir; sadece value bos kaldi
          }
        });
        // Ilk yazma aninda da default class kaldir — SADECE KULLANICI EVENT'LERI (isTrusted)
        // Programatik dispatchEvent (triggerDefaultCalc'tan) tetiklenmesini engelle
        el.addEventListener('input', function(e) {
          if (!e.isTrusted) return;
          // Dolce Vita yeni siparis akisi bos olcuyu bilincli bir kullanici
          // durumu sayar. Gecikmeli varsayilanlar silinen degeri geri yazamaz.
          if (dvRoot) {
            el.classList.remove('bp-showing-default');
            el.dataset.userEdited = '1';
            return;
          }
          if (el.value && el.classList.contains('bp-showing-default')) {
            el.classList.remove('bp-showing-default');
            el.dataset.userEdited = '1';
          }
        });
      }
      setupOne(wEl);
      setupOne(lEl);
    }

    // Init
    setTimeout(function() { initSliders(); }, 200);
    // FIX 2026-05-11: Focus-clear handler — kullanici silik default'u tiklayinca temizler
    setTimeout(function() { setupDefaultClearOnFocus(); }, 250);
    setTimeout(triggerDefaultCalc, 1000);
  })();



    function reorderTrustSection() {
    var _trust = document.querySelector('.bp-trust');
    var _share = document.querySelector('.bp-share');
    var _timeline = _trust ? _trust.querySelector('.bp-delivery-timeline') : null;
    var _parent = _share ? _share.parentNode : null;
    if (_trust && _share && _timeline && _parent) {
      _parent.insertBefore(_timeline, _share);
      console.log('[BannerProduct] DOM reorder: Timeline → Share → Trust');
    }

    // FIX 2026-05-12: header etiketlerini teslimat zaman cizelgesinin altinda tut.
    var _tags = document.querySelector('.bp-header-tags');
    if (_tags && _timeline && _timeline.parentNode) {
      _timeline.parentNode.insertBefore(_tags, _timeline.nextSibling);
      console.log('[BannerProduct] DOM reorder: header-tags → Timeline sonrasına taşındı');
    }
  }

})();

/* --------------------------------------------------------------------------
   Dolce Vita özel ölçü — Akıllı Satın Alma Dock'u
   Mevcut #ozel-olcu-add-to-cart düğmesini ve hesaplanmış DOM durumunu yansıtır.
   Ayrı fiyat, stok veya /cart/add isteği çalıştırmaz.
   -------------------------------------------------------------------------- */
(function() {
  'use strict';

  function onReady(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn, { once: true });
    else fn();
  }

  onReady(function initDolceVitaPurchaseDock() {
    var root = document.getElementById('banner-product');
    if (!root || root.getAttribute('data-dv-purchase-dock-mounted') === 'true') return;

    var handle = String(root.getAttribute('data-product-handle') || '').toLowerCase();
    var isDolceVitaCut = root.getAttribute('data-configurator-brand') === 'dolce-vita' &&
      root.getAttribute('data-dv-order-flow') === 'visual-v3' &&
      handle.indexOf('dolce-vita-hali-') === 0; /* [DV-FLOW-GATE 2026-07-30] handle token sarti kaldirildi; nitelikleri zaten Liquid kapisi basiyor */
    if (!isDolceVitaCut) return;

    var sourceButton = document.getElementById('ozel-olcu-add-to-cart');
    var sourceButtonText = document.getElementById('ozel-olcu-btn-text');
    var sourceSpinner = document.getElementById('ozel-olcu-btn-spinner');
    var widthInput = document.getElementById('ozel-olcu-width');
    var lengthInput = document.getElementById('ozel-olcu-length');
    var priceEl = document.getElementById('ozel-olcu-price');
    var comparePriceEl = document.getElementById('ozel-olcu-compare-price');
    var priceWrap = document.getElementById('ozel-olcu-price-display');
    var stockStatus = document.getElementById('ozel-olcu-stock-status');
    var stockText = document.getElementById('ozel-olcu-stock-text');
    var form = document.getElementById('ozel-olcu-plus');
    var dims = document.getElementById('bp-dims-inline');
    var rightColumn = root.querySelector('.bp-right-col');

    if (!sourceButton || !sourceButtonText || !widthInput || !lengthInput || !form || !dims) return;

    root.setAttribute('data-dv-purchase-dock-mounted', 'true');

    var dock = document.createElement('aside');
    dock.id = 'dv-purchase-dock';
    dock.className = 'dv-purchase-dock';
    dock.setAttribute('role', 'region');
    dock.setAttribute('aria-label', 'Satın alma özeti');
    dock.setAttribute('aria-hidden', 'true');
    dock.hidden = false;
    dock.innerHTML =
      '<div class="dv-purchase-dock__summary">' +
        '<div class="dv-purchase-dock__config" id="dv-purchase-dock-config">Ölçüyü tamamlayın</div>' +
        '<div class="dv-purchase-dock__price-row">' +
          '<span class="dv-purchase-dock__price-stage" id="dv-purchase-dock-price-stage" role="text">' +
            '<span class="dv-purchase-dock__compare" id="dv-purchase-dock-compare" aria-hidden="true"></span>' +
            '<span class="dv-purchase-dock__price-arrow" aria-hidden="true">→</span>' +
            '<strong class="dv-purchase-dock__price" id="dv-purchase-dock-price" aria-hidden="true">—</strong>' +
          '</span>' +
          '<span class="dv-purchase-dock__status" id="dv-purchase-dock-status" aria-live="polite"></span>' +
        '</div>' +
        '<span class="dv-purchase-dock__promotion" id="dv-purchase-dock-promotion" aria-live="polite" hidden></span>' +
      '</div>' +
      '<button class="dv-purchase-dock__button" id="dv-purchase-dock-button" type="button">ÖLÇÜ GİRİP SEPETE EKLE</button>';
    root.appendChild(dock);

    var dockConfig = document.getElementById('dv-purchase-dock-config');
    var dockPriceStage = document.getElementById('dv-purchase-dock-price-stage');
    var dockCompare = document.getElementById('dv-purchase-dock-compare');
    var dockPriceArrow = dockPriceStage.querySelector('.dv-purchase-dock__price-arrow');
    var dockPrice = document.getElementById('dv-purchase-dock-price');
    var dockStatus = document.getElementById('dv-purchase-dock-status');
    var dockPromotion = document.getElementById('dv-purchase-dock-promotion');
    var dockButton = document.getElementById('dv-purchase-dock-button');

    var configuratorSeen = false;
    var dockVisible = false;
    var syncFrame = 0;
    var proxyLocked = false;
    var movedFloaters = [];
    var variantPricing = null;
    var currentVariantId = String(root.getAttribute('data-product-variant-id') || '');
    var discountEligibilityUrl = String(root.getAttribute('data-dv-discount-eligibility-url') || '');
    var eligibilityRefreshTimer = 0;
    var eligibilityRequestKey = '';
    var eligibilityController = null;
    var cartDiscountEligibility = {
      verified: false,
      eligible: false,
      percentage: 0,
      minimum: null,
      validUntil: ''
    };

    function foldText(value) {
      return String(value || '')
        .toLocaleLowerCase('tr-TR')
        .replace(/ı/g, 'i')
        .replace(/ş/g, 's')
        .replace(/ğ/g, 'g')
        .replace(/ü/g, 'u')
        .replace(/ö/g, 'o')
        .replace(/ç/g, 'c');
    }

    function isRendered(el) {
      if (!el || !el.isConnected || el.getClientRects().length === 0) return false;
      var style = window.getComputedStyle(el);
      return style.display !== 'none' && style.visibility !== 'hidden' && parseFloat(style.opacity || '1') > 0.05;
    }

    function isInViewport(el) {
      if (!isRendered(el)) return false;
      var rect = el.getBoundingClientRect();
      return rect.bottom > 0 && rect.top < window.innerHeight && rect.right > 0 && rect.left < window.innerWidth;
    }

    function hasUsableSourceVisibility() {
      if (!isRendered(sourceButton)) return false;
      var rect = sourceButton.getBoundingClientRect();
      var reservedBottom = window.innerWidth < 768 ? 108 : 116;
      var visibleTop = Math.max(0, rect.top);
      var visibleBottom = Math.min(window.innerHeight - reservedBottom, rect.bottom);
      var visibleHeight = Math.max(0, visibleBottom - visibleTop);
      return visibleHeight >= Math.min(44, rect.height * 0.75);
    }

    function getEdgeLabel() {
      var checked = form.querySelector('input[name="ozel-olcu-edge"]:checked');
      if (!checked) return '';
      var label = checked.closest('[data-edge]');
      var visibleLabel = label && label.querySelector('.ozel-olcu-plus__radio-label');
      var raw = visibleLabel ? visibleLabel.textContent : checked.value;
      raw = String(raw || '').trim();
      return raw ? raw.charAt(0).toLocaleUpperCase('tr-TR') + raw.slice(1) : '';
    }

    function getShapeLabel() {
      var shape = document.getElementById('ozel-olcu-shape');
      var labels = { dikdortgen: 'Dikdörtgen', daire: 'Yuvarlak', oval: 'Oval', amorf: 'Amorf' };
      return shape ? (labels[shape.value] || shape.value || '') : '';
    }

    function getAlternatives() {
      var container = document.getElementById('ozel-olcu-pattern-alternatives');
      var cards = container ? Array.prototype.slice.call(container.querySelectorAll('.ozel-olcu-plus__pattern-alt-card')) : [];
      cards = cards.filter(isRendered);
      return {
        container: container,
        cards: cards,
        loading: !!(container && container.getAttribute('aria-busy') === 'true')
      };
    }

    function getPriceText(stateName) {
      var priceIsCurrent = stateName === 'ready' || stateName === 'success' || stateName === 'submitting';
      if (!priceIsCurrent || !priceEl || !priceWrap || !isRendered(priceWrap)) return '—';
      return String(priceEl.textContent || '').trim() || '—';
    }

    function getPricePresentation(stateName) {
      var priceText = getPriceText(stateName);
      var compareText = comparePriceEl && priceText !== '—'
        ? String(comparePriceEl.textContent || '').trim()
        : '';
      var priceValue = variantPricing ? variantPricing.price : 0;
      var compareValue = variantPricing ? variantPricing.compareAtPrice : 0;
      var hasPromotion = stateName === 'ready' &&
        priceText !== '—' &&
        compareText !== '' &&
        priceValue > 0 &&
        compareValue > priceValue;
      var productDiscountPercent = hasPromotion
        ? Math.round(((compareValue - priceValue) / compareValue) * 100)
        : 0;
      var validUntil = Date.parse(cartDiscountEligibility.validUntil || '');
      var eligibilityIsCurrent = cartDiscountEligibility.verified &&
        cartDiscountEligibility.eligible &&
        cartDiscountEligibility.percentage > 0 &&
        Number.isFinite(validUntil) &&
        validUntil > Date.now();
      var minimum = cartDiscountEligibility.minimum;
      var minimumSatisfied = !minimum ||
        (minimum.type === 'subtotal' && priceValue / 100 >= Number(minimum.value || 0)) ||
        (minimum.type === 'quantity' && Number(minimum.value || 0) <= 1);
      var cartDiscountPercent = eligibilityIsCurrent && minimumSatisfied
        ? cartDiscountEligibility.percentage
        : 0;
      // DV_VERIFIED_CHECKOUT_PRICE_V2_20260729
      var checkoutPriceCents = priceValue;
      var checkoutPriceText = priceText;
      if (cartDiscountPercent > 0 && priceValue > 0 && priceText !== '—') {
        checkoutPriceCents = Math.round(
          priceValue * (1 - cartDiscountPercent / 100)
        );
        checkoutPriceText = formatTryFromCents(checkoutPriceCents);
      }
      var promotionText = hasPromotion
        ? '%' + formatPercent(productDiscountPercent) + ' \u00fcr\u00fcn' +
          (cartDiscountPercent > 0 ? ' + sepette %' + formatPercent(cartDiscountPercent) : ' indirimi')
        : (cartDiscountPercent > 0
          ? 'Sepette %' + formatPercent(cartDiscountPercent) + ' indirim'
          : '');
      var priceAriaLabel = hasPromotion
        ? 'Eski fiyat ' + compareText + '. \u00dcr\u00fcn fiyat\u0131 ' + priceText + '. Y\u00fczde ' +
          formatPercent(productDiscountPercent) + ' \u00fcr\u00fcn indirimi.' +
          (cartDiscountPercent > 0
            ? ' Sepette ek y\u00fczde ' + formatPercent(cartDiscountPercent) +
              ' indirimli \u00f6deme tutar\u0131 ' + checkoutPriceText + '.'
            : '')
        : (cartDiscountPercent > 0
          ? 'Fiyat ' + priceText + '. Sepette y\u00fczde ' +
            formatPercent(cartDiscountPercent) +
            ' indirimli \u00f6deme tutar\u0131 ' + checkoutPriceText + '.'
          : 'Fiyat ' + priceText);

      return {
        priceText: checkoutPriceText,
        compareText: hasPromotion ? compareText : (cartDiscountPercent > 0 ? priceText : ''),
        hasPromotion: hasPromotion || cartDiscountPercent > 0,
        productDiscountPercent: productDiscountPercent,
        cartDiscountPercent: cartDiscountPercent,
        checkoutPriceCents: checkoutPriceCents,
        promotionText: promotionText,
        priceAriaLabel: priceAriaLabel
      };
    }

    function formatTryFromCents(value) {
      return new Intl.NumberFormat('tr-TR', {
        style: 'currency',
        currency: 'TRY'
      }).format(Number(value || 0) / 100);
    }

    function formatPercent(value) {
      var rounded = Math.round(Number(value || 0) * 10) / 10;
      return String(rounded).replace('.', ',');
    }

    function syncPricePresentation(presentation) {
      // DV_VERIFIED_CHECKOUT_SURFACES_V3_20260729
      if (dockPrice.textContent !== presentation.priceText) {
        dockPrice.textContent = presentation.priceText;
      }
      if (dockCompare.textContent !== presentation.compareText) {
        dockCompare.textContent = presentation.compareText;
      }
      if (dockPromotion.textContent !== presentation.promotionText) {
        dockPromotion.textContent = presentation.promotionText;
      }
      dockPriceStage.setAttribute('aria-label', presentation.priceAriaLabel);
      dockPriceArrow.hidden = !presentation.hasPromotion;
      dockPromotion.hidden = !presentation.hasPromotion;
      dock.setAttribute('data-has-promotion', presentation.hasPromotion ? 'true' : 'false');
      dock.setAttribute(
        'data-product-discount-percent',
        presentation.productDiscountPercent > 0 ? String(presentation.productDiscountPercent) : ''
      );
      dock.dataset.cartDiscountPercent =
        presentation.cartDiscountPercent > 0 ? String(presentation.cartDiscountPercent) : '';
      dock.dataset.checkoutPriceCents =
        presentation.checkoutPriceCents > 0 ? String(presentation.checkoutPriceCents) : '';

      var mainCheckoutPrice = document.getElementById('dv-verified-checkout-main');
      if (!mainCheckoutPrice && priceWrap) {
        mainCheckoutPrice = document.createElement('span');
        mainCheckoutPrice.id = 'dv-verified-checkout-main';
        mainCheckoutPrice.className = 'dv-verified-checkout-main';
        mainCheckoutPrice.setAttribute('aria-live', 'polite');
        priceWrap.appendChild(mainCheckoutPrice);
      }
      if (mainCheckoutPrice) {
        var showCheckoutPrice = presentation.cartDiscountPercent > 0 &&
          presentation.checkoutPriceCents > 0 &&
          presentation.priceText !== '—';
        var mainCheckoutText = showCheckoutPrice
          ? 'Sepette ödenecek: ' + presentation.priceText
          : '';
        if (mainCheckoutPrice.hidden !== !showCheckoutPrice) {
          mainCheckoutPrice.hidden = !showCheckoutPrice;
        }
        if (mainCheckoutPrice.textContent !== mainCheckoutText) {
          mainCheckoutPrice.textContent = mainCheckoutText;
        }
      }
    }

    function resetCartDiscountEligibility() {
      cartDiscountEligibility = {
        verified: false,
        eligible: false,
        percentage: 0,
        minimum: null,
        validUntil: ''
      };
      scheduleSync();
      if (discountEligibilityUrl) {
        if (eligibilityRefreshTimer) window.clearTimeout(eligibilityRefreshTimer);
        eligibilityRefreshTimer = window.setTimeout(loadCartDiscountEligibility, 10000);
      }
    }

    function applyCartDiscountEligibility(payload) {
      var discount = payload && payload.discount;
      var percentage = discount && discount.type === 'percentage'
        ? Number(discount.value)
        : 0;
      var validUntilMs = Date.parse(payload && payload.validUntil || '');
      var verified = !!(payload && payload.ok && payload.verified);
      var eligible = !!(verified && payload.eligible && percentage > 0 &&
        Number.isFinite(validUntilMs) && validUntilMs > Date.now());

      cartDiscountEligibility = {
        verified: verified,
        eligible: eligible,
        percentage: eligible ? percentage : 0,
        minimum: eligible ? (discount.minimum || null) : null,
        validUntil: eligible ? payload.validUntil : ''
      };
      scheduleSync();

      if (eligibilityRefreshTimer) window.clearTimeout(eligibilityRefreshTimer);
      var refreshIn = eligible
        ? Math.max(1000, Math.min(30000, validUntilMs - Date.now() + 25))
        : 10000;
      eligibilityRefreshTimer = window.setTimeout(loadCartDiscountEligibility, refreshIn);
    }

    function getEligibilityCacheKey() {
      return 'dv:auto-discount:v2:' + handle + ':' + (currentVariantId || '-');
    }

    function readEligibilityCache(cacheKey) {
      try {
        var raw = window.sessionStorage && window.sessionStorage.getItem(cacheKey);
        if (!raw) return null;
        var parsed = JSON.parse(raw);
        var validUntilMs = Date.parse(parsed && parsed.payload && parsed.payload.validUntil || '');
        var maxAge = parsed && parsed.payload && parsed.payload.eligible ? 30000 : 10000;
        if (!Number.isFinite(parsed.storedAt) || Date.now() - parsed.storedAt > maxAge ||
            !Number.isFinite(validUntilMs) || validUntilMs <= Date.now()) {
          window.sessionStorage.removeItem(cacheKey);
          return null;
        }
        return parsed.payload;
      } catch (_) {
        return null;
      }
    }

    function writeEligibilityCache(cacheKey, payload) {
      if (!payload || !payload.ok || !payload.verified) return;
      try {
        if (window.sessionStorage) {
          window.sessionStorage.setItem(cacheKey, JSON.stringify({
            storedAt: Date.now(),
            payload: payload
          }));
        }
      } catch (_) {
        // Storage kapalıysa karar yalnızca bellekte kullanılır.
      }
    }

    function loadCartDiscountEligibility(force) {
      if (!discountEligibilityUrl || !window.fetch) {
        resetCartDiscountEligibility();
        return;
      }

      var requestKey = handle + '|' + (currentVariantId || '-');
      var cacheKey = getEligibilityCacheKey();
      var cached = !force ? readEligibilityCache(cacheKey) : null;
      if (cached) {
        eligibilityRequestKey = requestKey;
        applyCartDiscountEligibility(cached);
        return;
      }

      if (eligibilityController && typeof eligibilityController.abort === 'function') {
        eligibilityController.abort();
      }
      eligibilityController = 'AbortController' in window ? new AbortController() : null;
      eligibilityRequestKey = requestKey;

      var endpoint;
      try {
        endpoint = new URL(discountEligibilityUrl, window.location.href);
        endpoint.searchParams.set('handle', handle);
        if (currentVariantId) endpoint.searchParams.set('variantId', currentVariantId);
      } catch (_) {
        resetCartDiscountEligibility();
        return;
      }

      var timeoutId = window.setTimeout(function() {
        if (eligibilityController) eligibilityController.abort();
      }, 2800);

      window.fetch(endpoint.toString(), {
        method: 'GET',
        mode: 'cors',
        credentials: 'omit',
        cache: 'no-store',
        headers: { Accept: 'application/json' },
        signal: eligibilityController ? eligibilityController.signal : undefined
      }).then(function(response) {
        if (!response.ok) throw new Error('eligibility_http_' + response.status);
        return response.json();
      }).then(function(payload) {
        if (eligibilityRequestKey !== requestKey) return;
        writeEligibilityCache(cacheKey, payload);
        applyCartDiscountEligibility(payload);
      }).catch(function() {
        if (eligibilityRequestKey !== requestKey) return;
        resetCartDiscountEligibility();
      }).finally(function() {
        window.clearTimeout(timeoutId);
      });
    }

    function getState() {
      var width = parseInt(widthInput.value, 10);
      var length = parseInt(lengthInput.value, 10);
      var sourceText = String(sourceButtonText.textContent || '').trim();
      var folded = foldText(sourceText);
      var stockMessage = stockText ? String(stockText.textContent || '').trim() : '';
      var foldedStock = foldText(stockMessage);
      var alternatives = getAlternatives();
      var spinnerVisible = sourceSpinner && isRendered(sourceSpinner) && sourceSpinner.style.display !== 'none';

      if (!width || width < 50 || width > 200 || !length || length < 50 || length > 600) {
        return { name: 'incomplete', label: 'ÖLÇÜ GİRİP SEPETE EKLE', status: 'Ölçüyü tamamlayın', disabled: false, sourceText: sourceText, alternatives: alternatives };
      }

      if (sourceButton.classList.contains('success') || folded.indexOf('sepete eklendi') !== -1) {
        return { name: 'success', label: '✓ SEPETE EKLENDİ', status: '', disabled: true, sourceText: sourceText, alternatives: alternatives };
      }

      if (spinnerVisible || folded.indexOf('isleniyor') !== -1 || folded.indexOf('ekleniyor') !== -1) {
        return { name: 'submitting', label: 'SEPETE EKLENİYOR…', status: 'Sipariş hazırlanıyor', disabled: true, sourceText: sourceText, alternatives: alternatives };
      }

      if ((stockStatus && stockStatus.classList.contains('stock-loading')) || folded.indexOf('stok kontrol') !== -1 || alternatives.loading) {
        return { name: 'checking', label: alternatives.loading ? 'STOKLU DESENLER ARANIYOR…' : 'STOK KONTROL EDİLİYOR…', status: stockMessage || 'Stok kontrol ediliyor', disabled: true, sourceText: sourceText, alternatives: alternatives };
      }

      if (stockStatus && stockStatus.classList.contains('stock-error') &&
          (foldedStock.indexOf('hata') !== -1 || foldedStock.indexOf('kontrol edilemedi') !== -1 || foldedStock.indexOf('ulasilamadi') !== -1)) {
        return {
          name: 'error',
          label: 'TEKRAR KONTROL ET',
          status: stockMessage || 'Stok şu anda kontrol edilemiyor',
          disabled: false,
          sourceText: sourceText,
          alternatives: alternatives
        };
      }

      if ((stockStatus && stockStatus.classList.contains('stock-error')) || folded.indexOf('stok yok') !== -1 || folded.indexOf('stok bulunm') !== -1) {
        return {
          name: 'stock-out',
          label: alternatives.cards.length ? 'STOKTAKİ ' + alternatives.cards.length + ' DESENİ GÖR' : 'FARKLI ÖLÇÜ DENE',
          status: stockMessage || 'Bu ölçüde stok yok',
          disabled: false,
          sourceText: sourceText,
          alternatives: alternatives
        };
      }

      if (!sourceButton.disabled && stockStatus && stockStatus.classList.contains('stock-ok')) {
        return { name: 'ready', label: 'SEPETE EKLE', status: stockMessage, disabled: false, sourceText: sourceText, alternatives: alternatives };
      }

      if (folded.indexOf('kumas') !== -1 || folded.indexOf('biye') !== -1 || folded.indexOf('renk sec') !== -1) {
        return { name: 'needs-option', label: 'KUMAŞ SEÇ', status: sourceText || 'Kumaş seçimi gerekli', disabled: false, sourceText: sourceText, alternatives: alternatives };
      }

      return {
        name: 'checking',
        label: 'STOK KONTROL EDİLİYOR…',
        status: stockMessage || sourceText || 'Seçimler kontrol ediliyor',
        disabled: true,
        sourceText: sourceText,
        alternatives: alternatives
      };
    }

    function isDialogOpen() {
      var selectors = [
        '#CartDrawer[open]',
        '#CartDrawer[aria-hidden="false"]',
        '#CartDrawer.active',
        '#CartDrawer.is-open',
        'dialog[open]',
        '[role="dialog"][aria-modal="true"]:not([aria-hidden="true"])',
        '.hdt-modal[open]',
        '.hdt-modal.active',
        '.hdt-modal.is-open',
        '.hdt-drawer[open]',
        '.hdt-drawer.active',
        '.hdt-drawer.is-open',
        '[data-cart-drawer].active',
        '[data-cart-drawer].is-open'
      ];
      for (var i = 0; i < selectors.length; i += 1) {
        var candidates = document.querySelectorAll(selectors[i]);
        for (var j = 0; j < candidates.length; j += 1) {
          if (isRendered(candidates[j])) return true;
        }
      }
      return false;
    }

    function isMobileInputActive() {
      if (window.innerWidth >= 768) return false;
      var active = document.activeElement;
      if (!active || !/^(INPUT|TEXTAREA|SELECT)$/.test(active.tagName)) return false;
      if (!form.contains(active) && !dims.contains(active)) return false;
      if (!window.visualViewport) return true;
      return (window.innerHeight - window.visualViewport.height) > 100 || active === widthInput || active === lengthInput;
    }

    function wouldCoverConfiguratorControls() {
      if (window.innerWidth >= 768 || root.getAttribute('data-dv-order-flow') !== 'visual-v3') return false;
      var dockTop = window.innerHeight - 104 - Math.max(0, parseInt(getComputedStyle(document.documentElement).getPropertyValue('--safe-area-inset-bottom'), 10) || 0);
      var controls = [
        document.getElementById('bp-shape-section'),
        dims,
        document.getElementById('bp-edge-section'),
        stockStatus
      ];
      for (var i = 0; i < controls.length; i += 1) {
        if (!isRendered(controls[i])) continue;
        var rect = controls[i].getBoundingClientRect();
        if (rect.bottom > dockTop && rect.top < window.innerHeight) return true;
      }
      return false;
    }

    function updateDesktopGeometry() {
      if (window.innerWidth < 768 || !rightColumn) {
        dock.style.removeProperty('--dv-dock-desktop-left');
        dock.style.removeProperty('--dv-dock-desktop-width');
        return;
      }
      var rect = rightColumn.getBoundingClientRect();
      var width = Math.min(520, Math.max(320, rect.width - 32));
      var left = rect.left + Math.max(16, (rect.width - width) / 2);
      left = Math.max(12, Math.min(left, window.innerWidth - width - 12));
      dock.style.setProperty('--dv-dock-desktop-left', Math.round(left) + 'px');
      dock.style.setProperty('--dv-dock-desktop-width', Math.round(width) + 'px');
    }

    function updateFloatingControls(visible) {
      if (!visible) {
        movedFloaters.forEach(function(el) { if (el && el.classList) el.classList.remove('dv-purchase-dock-offset'); });
        movedFloaters = [];
        document.body.classList.remove('dv-purchase-dock-active');
        return;
      }

      document.body.classList.add('dv-purchase-dock-active');
      var selector = [
        'a[href*="wa.me"]',
        'a[href*="whatsapp"]',
        '[class*="whatsapp" i]',
        '[id*="whatsapp" i]',
        '[class*="back-to-top" i]',
        '[id*="back-to-top" i]',
        '[class*="scroll-top" i]',
        '#shop-hcaptcha-badge-container'
      ].join(',');
      var candidates = document.querySelectorAll(selector);
      movedFloaters = [];
      for (var i = 0; i < candidates.length; i += 1) {
        var el = candidates[i];
        if (dock.contains(el)) continue;
        var target = el;
        var climbCount = 0;
        while (target.parentElement && target.parentElement !== document.body &&
               window.getComputedStyle(target).position !== 'fixed' && climbCount < 5) {
          target = target.parentElement;
          climbCount += 1;
        }
        var style = window.getComputedStyle(target);
        var rect = target.getBoundingClientRect();
        var isCaptchaBadge = target.id === 'shop-hcaptcha-badge-container';
        if (style.position === 'fixed' && (isCaptchaBadge || (rect.width <= 140 && rect.height <= 140)) && rect.bottom > window.innerHeight - 180) {
          if (movedFloaters.indexOf(target) === -1) {
            target.classList.add('dv-purchase-dock-offset');
            movedFloaters.push(target);
          }
        }
      }
    }

    function setVisible(visible) {
      if (dockVisible === visible) {
        if (visible) updateFloatingControls(true);
        return;
      }
      dockVisible = visible;
      if (!visible && dock.contains(document.activeElement) && typeof document.activeElement.blur === 'function') {
        document.activeElement.blur();
      }
      dock.classList.toggle('is-visible', visible);
      dock.setAttribute('aria-hidden', visible ? 'false' : 'true');
      root.classList.toggle('dv-purchase-dock-visible', visible);
      updateFloatingControls(visible);
    }

    function syncDock() {
      syncFrame = 0;
      if (!root.isConnected || !sourceButton.isConnected) return;

      var dimsRect = dims.getBoundingClientRect();
      if (dimsRect.top < window.innerHeight * 0.92) configuratorSeen = true;

      var width = parseInt(widthInput.value, 10);
      var length = parseInt(lengthInput.value, 10);
      var edge = getEdgeLabel();
      var shape = getShapeLabel();
      var state = getState();
      var fullConfigText = (width || '—') + ' × ' + (length || '—') + ' cm' +
        (shape ? ' · ' + shape : '') + (edge ? ' · ' + edge : '');
      var compactShape = shape && foldText(shape) !== 'dikdortgen' ? ' · ' + shape : '';
      var configText = window.innerWidth < 768
        ? (width || '—') + '×' + (length || '—') + compactShape + (edge ? ' · ' + edge : '')
        : fullConfigText;
      var pricePresentation = getPricePresentation(state.name);
      var priceText = pricePresentation.priceText;

      if (dockConfig.textContent !== configText) dockConfig.textContent = configText;
      syncPricePresentation(pricePresentation);
      if (dockStatus.textContent !== (state.status || '')) dockStatus.textContent = state.status || '';
      if (dockButton.textContent !== state.label) dockButton.textContent = state.label;
      dockButton.disabled = !!state.disabled;
      dockButton.setAttribute('aria-disabled', state.disabled ? 'true' : 'false');
      dockButton.setAttribute('aria-busy', state.name === 'checking' || state.name === 'submitting' ? 'true' : 'false');
      dockButton.setAttribute('aria-label', state.label + '. ' + fullConfigText + '. ' + priceText);
      dock.setAttribute('data-state', state.name);
      dock._dvState = state;

      updateDesktopGeometry();

      var rootRect = root.getBoundingClientRect();
      var productVisible = rootRect.bottom > 80 && rootRect.top < window.innerHeight;
      var sourceVisible = hasUsableSourceVisibility();
      var mobileReady = window.innerWidth < 768 && state.name === 'ready';
      var shouldShow = (configuratorSeen || mobileReady) &&
        productVisible && !sourceVisible && !isDialogOpen() &&
        !isMobileInputActive() &&
        (mobileReady || !wouldCoverConfiguratorControls());
      setVisible(shouldShow);
    }

    function scheduleSync() {
      if (syncFrame) return;
      syncFrame = window.requestAnimationFrame(syncDock);
    }

    function scrollAndFocus(el) {
      if (!el) return;
      var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      function focusTarget() {
        if (!el || !el.isConnected || typeof el.focus !== 'function') return;
        try { el.focus({ preventScroll: true }); }
        catch (focusErr) { el.focus(); }
      }
      focusTarget();
      try { el.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'center' }); }
      catch (err) { el.scrollIntoView(); }
      window.setTimeout(function() {
        focusTarget();
      }, reduceMotion ? 0 : 320);
    }

    dockButton.addEventListener('click', function() {
      if (dockButton.disabled || proxyLocked) return;
      var state = dock._dvState || getState();

      if (state.name === 'ready') {
        proxyLocked = true;
        sourceButton.click();
        scheduleSync();
        window.setTimeout(function() { proxyLocked = false; scheduleSync(); }, 1200);
        return;
      }

      if (state.name === 'stock-out') {
        if (state.alternatives.cards.length) scrollAndFocus(state.alternatives.cards[0]);
        else scrollAndFocus(lengthInput);
        return;
      }

      if (state.name === 'needs-option') {
        var fabric = document.querySelector('#ozel-olcu-color-options button, #ozel-olcu-color-options input, #ozel-olcu-color-options [tabindex]');
        scrollAndFocus(fabric || document.getElementById('ozel-olcu-color-options'));
        return;
      }

      if (state.name === 'error') {
        lengthInput.dispatchEvent(new Event('input', { bubbles: true }));
        scrollAndFocus(lengthInput);
        return;
      }

      var widthValue = parseInt(widthInput.value, 10);
      var lengthValue = parseInt(lengthInput.value, 10);
      if (!widthValue || widthValue < 50 || widthValue > 200) scrollAndFocus(widthInput);
      else if (!lengthValue || lengthValue < 50 || lengthValue > 600) scrollAndFocus(lengthInput);
    });

    form.addEventListener('input', scheduleSync, true);
    form.addEventListener('change', scheduleSync, true);
    dims.addEventListener('input', scheduleSync, true);
    dims.addEventListener('change', scheduleSync, true);
    document.addEventListener('variant:change', function(event) {
      var variant = event.detail && event.detail.variant;
      var price = variant ? Number(variant.price) : 0;
      var compareAtPrice = variant ? Number(variant.compare_at_price) : 0;
      var nextVariantId = variant && variant.id ? String(variant.id) : currentVariantId;
      variantPricing = Number.isFinite(price) && Number.isFinite(compareAtPrice)
        ? { price: price, compareAtPrice: compareAtPrice }
        : null;
      if (nextVariantId && nextVariantId !== currentVariantId) {
        currentVariantId = nextVariantId;
        loadCartDiscountEligibility(true);
      }
      scheduleSync();
    });
    document.addEventListener('cart:change', scheduleSync);
    window.addEventListener('ozel-olcu:pattern-bridge-ready', scheduleSync);
    window.addEventListener('amorf:render:complete', scheduleSync);
    window.addEventListener('scroll', scheduleSync, { passive: true });
    window.addEventListener('resize', scheduleSync, { passive: true });
    window.addEventListener('pageshow', scheduleSync);
    document.addEventListener('focusin', function() {
      if (isMobileInputActive()) setVisible(false);
      scheduleSync();
    });
    document.addEventListener('focusout', scheduleSync);
    // DV_INP_PRODUCT_SCHEDULING_FIX_20260730: only product/cart surfaces can invalidate the dock.
    document.addEventListener('click', function(event) {
      var target = event.target;
      if (!target || target.nodeType !== 1) return;
      var overlay = target.closest(
        '#CartDrawer, dialog, [role="dialog"], .hdt-modal, .hdt-drawer, [data-cart-drawer]'
      );
      if (!root.contains(target) && !overlay) return;
      scheduleSync();
    }, true);
    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', scheduleSync, { passive: true });
      window.visualViewport.addEventListener('scroll', scheduleSync, { passive: true });
    }

    var sourceObserver = new MutationObserver(scheduleSync);
    sourceObserver.observe(sourceButton, { attributes: true, childList: true, subtree: true, characterData: true });
    if (priceWrap) sourceObserver.observe(priceWrap, { attributes: true, childList: true, subtree: true, characterData: true });
    if (stockStatus && stockStatus.parentNode) {
      sourceObserver.observe(stockStatus.parentNode, { attributes: true, childList: true, subtree: true, characterData: true });
    }

    var overlayObserver = new MutationObserver(scheduleSync);
    var overlayCandidates = document.querySelectorAll('#CartDrawer, dialog, [role="dialog"], .hdt-modal, .hdt-drawer, [data-cart-drawer]');
    for (var overlayIndex = 0; overlayIndex < overlayCandidates.length; overlayIndex += 1) {
      overlayObserver.observe(overlayCandidates[overlayIndex], {
        attributes: true,
        attributeFilter: ['class', 'open', 'aria-hidden']
      });
    }

    if ('IntersectionObserver' in window) {
      var visibilityObserver = new IntersectionObserver(scheduleSync, { threshold: [0, 0.1, 0.75] });
      visibilityObserver.observe(sourceButton);
      visibilityObserver.observe(dims);
      visibilityObserver.observe(root);
    }

    window.setTimeout(loadCartDiscountEligibility, 0);
    window.setTimeout(scheduleSync, 80);
    window.setTimeout(scheduleSync, 500);
    window.setTimeout(scheduleSync, 1400);
  });
})();

/* DV_ORDER_FLOW_V3 */
(function() {
  'use strict';

  function onReady(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn, { once: true });
    else fn();
  }

  onReady(function initDolceVitaVisualOrderFlow() {
    var root = document.getElementById('banner-product');
    if (!root || root.getAttribute('data-dv-order-flow') !== 'visual-v3') return;

    var mount = document.getElementById('bp-dv-flow-mount');
    var shapeSection = document.getElementById('bp-shape-section');
    var dims = document.getElementById('bp-dims-inline');
    var edgeSection = document.getElementById('bp-edge-section');
    var edgeGroup = document.getElementById('ozel-olcu-edge-type');
    var fabricSection = document.querySelector('[data-dv-fabric-section]');
    var stockStatus = document.getElementById('ozel-olcu-stock-status');
    var stockText = document.getElementById('ozel-olcu-stock-text');
    var widthInput = document.getElementById('ozel-olcu-width');
    var lengthInput = document.getElementById('ozel-olcu-length');
    var widthLabel = document.querySelector('#bp-dsc-width .bp-dsc__label');
    var lengthCard = document.getElementById('bp-dsc-length');
    var dimSeparator = dims && dims.querySelector('.bp-dsc__sep');
    var shapeSelect = document.getElementById('ozel-olcu-shape');
    var shapeButtons = Array.prototype.slice.call(document.querySelectorAll('#bp-shape-btns .bp-shape-btn'));
    var priceEl = document.getElementById('ozel-olcu-price');
    var priceWrap = document.getElementById('ozel-olcu-price-display');
    var sourceButton = document.getElementById('ozel-olcu-add-to-cart');
    var selectedQuality = document.getElementById('bp-dv-selected-quality');
    var selectedPattern = document.getElementById('bp-dv-selected-pattern');
    var requestedSize = document.getElementById('bp-dv-requested-size');
    var productionSize = document.getElementById('bp-dv-production-size');
    var picker = document.getElementById('bp-dv-product-picker');
    var pickerTrigger = document.getElementById('bp-dv-change-product');
    var review = document.getElementById('bp-dv-order-review');
    var reviewConfirm = document.getElementById('bp-dv-review-confirm');
    var reviewStatus = document.getElementById('bp-dv-review-status');
    var reviewTitle = document.getElementById('bp-dv-review-title');
    var reviewDock = document.getElementById('dv-purchase-dock');
    var lastReviewTrigger = null;
    var circleSyncLocked = false;

    if (!mount || !shapeSection || !dims || !edgeSection || !edgeGroup || !widthInput || !lengthInput || !shapeSelect) return;

    var dvpSizeMount = document.getElementById('dvp-card-size-mount') || mount;
    var dvpShapeMount = document.getElementById('dvp-card-shape-mount') || mount;
    [[dims, dvpSizeMount], [stockStatus, dvpSizeMount], [shapeSection, dvpShapeMount], [edgeSection, dvpShapeMount], [fabricSection, dvpShapeMount]].forEach(function(pair) {
      var node = pair[0];
      if (!node) return;
      node.classList.add('bp-dv-flow-node');
      pair[1].appendChild(node);
    });
    root.classList.add('bp-dv-flow-ready');

    widthInput.setAttribute('aria-label', 'En, santimetre');
    lengthInput.setAttribute('aria-label', 'Boy, santimetre');

    function getConfig() {
      return window.__OZEL_OLCU_CONFIG__ || {};
    }

    function titleCase(value) {
      return String(value || '')
        .replace(/[-_]+/g, ' ')
        .replace(/\b\w/g, function(letter) { return letter.toLocaleUpperCase('tr-TR'); })
        .trim();
    }

    function getShapeLabel() {
      var labels = { dikdortgen: 'Dikdörtgen', daire: 'Yuvarlak', oval: 'Oval', amorf: 'Amorf' };
      return labels[shapeSelect.value] || titleCase(shapeSelect.value);
    }

    function getEdgeLabel() {
      var checked = edgeGroup.querySelector('input[name="ozel-olcu-edge"]:checked');
      if (!checked) return 'Seçilmedi';
      var label = checked.closest('[data-edge]');
      var text = label && label.querySelector('.ozel-olcu-plus__radio-label');
      return String(text ? text.textContent : checked.value).trim();
    }

    function getSnappedWidth(rawWidth) {
      var ranges = getConfig().snapRanges || [];
      for (var i = 0; i < ranges.length; i += 1) {
        if (rawWidth >= Number(ranges[i].min) && rawWidth <= Number(ranges[i].max)) {
          return Number(ranges[i].snap);
        }
      }
      return rawWidth || 0;
    }

    function updateSelectedProduct() {
      var config = getConfig();
      var quality = String(config.qualityCode || 'Dolce Vita').trim();
      var pattern = String(config.patternCode || '').trim();
      if (selectedQuality) selectedQuality.textContent = quality;
      if (selectedPattern) {
        var title = document.getElementById('bp-title');
        selectedPattern.textContent = pattern || String(title && title.textContent || '').trim();
      }
      var reviewProduct = document.getElementById('bp-dv-review-product');
      if (reviewProduct) reviewProduct.textContent = [titleCase(quality), pattern].filter(Boolean).join(' · ');
    }

    function syncReviewReadiness() {
      var ready = !!sourceButton && !sourceButton.disabled &&
        (!reviewDock || reviewDock.getAttribute('data-state') === 'ready');
      if (reviewConfirm) {
        reviewConfirm.disabled = !ready;
        reviewConfirm.setAttribute('aria-disabled', ready ? 'false' : 'true');
        reviewConfirm.textContent = ready ? 'Onayla ve Sepete Ekle' : 'Kontrol ediliyor…';
      }
      if (reviewStatus) {
        reviewStatus.textContent = ready ? 'Sepete eklemeye hazır' : 'Sipariş bilgileri güncelleniyor';
      }
      if (reviewTitle) {
        reviewTitle.textContent = ready ? 'Son kez kontrol edin' : 'Lütfen kısa bir an bekleyin';
      }
      return ready;
    }

    function syncShapeA11y() {
      shapeButtons.forEach(function(button) {
        var active = button.getAttribute('data-shape') === shapeSelect.value;
        button.setAttribute('aria-pressed', active ? 'true' : 'false');
        button.classList.toggle('active', active);
      });
    }

    function syncEdgeA11y() {
      var edgeLabels = edgeGroup.querySelectorAll('[data-edge]');
      for (var i = 0; i < edgeLabels.length; i += 1) {
        var radio = edgeLabels[i].querySelector('input[name="ozel-olcu-edge"]');
        edgeLabels[i].setAttribute('aria-checked', radio && radio.checked ? 'true' : 'false');
      }
    }

    function dispatchDimensionEvents(input) {
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }

    function syncCircleDimensions(dispatchEvents) {
      var isCircle = shapeSelect.value === 'daire';
      root.classList.toggle('bp-dv-shape-circle', isCircle);
      if (widthLabel) widthLabel.textContent = isCircle ? 'Çap' : 'En';
      widthInput.placeholder = isCircle ? 'Çap giriniz' : 'En giriniz';
      lengthInput.placeholder = 'Boy giriniz';
      widthInput.setAttribute('aria-label', isCircle ? 'Çap, santimetre' : 'En, santimetre');
      if (lengthCard) {
        lengthCard.setAttribute('aria-hidden', isCircle ? 'true' : 'false');
        Array.prototype.forEach.call(lengthCard.querySelectorAll('input, button, select, textarea'), function(control) {
          control.tabIndex = isCircle ? -1 : 0;
        });
      }
      if (dimSeparator) dimSeparator.setAttribute('aria-hidden', isCircle ? 'true' : 'false');

      if (!isCircle || circleSyncLocked) return;
      var diameter = parseInt(widthInput.value, 10);
      if (!diameter || String(lengthInput.value) === String(diameter)) return;
      circleSyncLocked = true;
      lengthInput.value = String(diameter);
      if (dispatchEvents) dispatchDimensionEvents(lengthInput);
      circleSyncLocked = false;
    }

    function updateSummary() {
      syncCircleDimensions(false);
      syncShapeA11y();
      syncEdgeA11y();
      updateSelectedProduct();

      var width = parseInt(widthInput.value, 10) || 0;
      var length = parseInt(lengthInput.value, 10) || 0;
      var snapped = getSnappedWidth(width);
      var isCircle = shapeSelect.value === 'daire';
      var requestedText = isCircle
        ? (width ? 'Çap ' + width + ' cm' : 'Çap girin')
        : ((width || '—') + ' × ' + (length || '—') + ' cm');
      var productionText = (snapped || '—') + ' × ' + (isCircle ? (width || '—') : (length || '—')) + ' cm';

      if (requestedSize) requestedSize.textContent = requestedText;
      if (productionSize) productionSize.textContent = productionText;

      var reviewShape = document.getElementById('bp-dv-review-shape');
      var reviewRequested = document.getElementById('bp-dv-review-requested');
      var reviewNetSize = document.getElementById('bp-dv-review-net-size');
      var reviewProduction = document.getElementById('bp-dv-review-production');
      var reviewEdge = document.getElementById('bp-dv-review-edge');
      var reviewFabricWrap = document.getElementById('bp-dv-review-fabric-wrap');
      var reviewFabric = document.getElementById('bp-dv-review-fabric');
      var reviewStock = document.getElementById('bp-dv-review-stock');
      var reviewStockWrap = document.getElementById('bp-dv-review-stock-wrap');
      var reviewStockLabel = document.getElementById('bp-dv-review-stock-label');
      var reviewPrice = document.getElementById('bp-dv-review-price');
      if (reviewShape) reviewShape.textContent = getShapeLabel();
      if (reviewRequested) reviewRequested.textContent = requestedText;
      if (reviewNetSize) reviewNetSize.textContent = requestedText;
      if (reviewProduction) reviewProduction.textContent = productionText;
      if (reviewEdge) reviewEdge.textContent = getEdgeLabel();
      if (reviewFabricWrap) {
        var selectedEdge = edgeGroup.querySelector('input[name="ozel-olcu-edge"]:checked');
        var selectedEdgeType = selectedEdge ? String(selectedEdge.value || '').toLowerCase() : '';
        var selectedFabric = root.querySelector('.ozel-olcu-plus__color-btn.active[data-color-id]');
        var selectedFabricId = selectedFabric ? String(selectedFabric.getAttribute('data-color-id') || '').trim() : '';
        var showFabric = (selectedEdgeType === 'biye' || selectedEdgeType === 'bordur') && !!selectedFabricId;
        reviewFabricWrap.hidden = !showFabric;
        if (reviewFabric) reviewFabric.textContent = showFabric ? selectedFabricId : '—';
      }
      if (reviewStock) {
        var rawStockText = String(stockText && stockText.textContent || 'Kontrol ediliyor').trim();
        var cleanStockText = rawStockText.replace(/^[✓✔]\s*/, '');
        var stockIsReady = /(uygun|mevcut|hazır)/i.test(rawStockText) && !/(yok|bulunamad|hata|doldu)/i.test(rawStockText);
        reviewStock.textContent = cleanStockText;
        if (reviewStockLabel) reviewStockLabel.textContent = stockIsReady ? 'Stok uygun' : 'Stok durumu';
        if (reviewStockWrap) reviewStockWrap.setAttribute('data-stock-ready', stockIsReady ? 'true' : 'false');
      }
      if (reviewPrice) {
        var priceIsVisible = priceWrap && window.getComputedStyle(priceWrap).display !== 'none';
        var verifiedDockPrice = reviewDock &&
          reviewDock.getAttribute('data-state') === 'ready'
          ? reviewDock.querySelector('#dv-purchase-dock-price')
          : null;
        reviewPrice.textContent = verifiedDockPrice && priceIsVisible
          ? (String(verifiedDockPrice.textContent || '').trim() || '—')
          : (priceEl && priceIsVisible ? (String(priceEl.textContent || '').trim() || '—') : '—');
      }
      syncReviewReadiness();
    }

    var summaryFrame = 0;
    function scheduleSummary() {
      if (summaryFrame) return;
      summaryFrame = window.requestAnimationFrame(function() {
        summaryFrame = 0;
        updateSummary();
      });
    }

    function openPicker() {
      if (!picker) return;
      picker.hidden = false;
      root.classList.add('bp-dv-picker-open');
      document.body.classList.add('bp-dv-modal-open');
      var firstTab = picker.querySelector('[role="tab"], button, [tabindex="0"]');
      if (firstTab && typeof firstTab.focus === 'function') window.setTimeout(function() { firstTab.focus(); }, 50);
    }

    function closePicker() {
      if (!picker) return;
      picker.hidden = true;
      root.classList.remove('bp-dv-picker-open');
      document.body.classList.remove('bp-dv-modal-open');
      if (pickerTrigger && typeof pickerTrigger.focus === 'function') pickerTrigger.focus();
    }

    function openReview(trigger) {
      if (!review) return;
      updateSummary();
      lastReviewTrigger = trigger || null;
      if (typeof review.showModal === 'function') review.showModal();
      else review.setAttribute('open', '');
      document.body.classList.add('bp-dv-modal-open');
      var closeButton = review.querySelector('[data-dv-review-close]');
      if (closeButton && typeof closeButton.focus === 'function') {
        window.setTimeout(function() {
          if (!review.open && !review.hasAttribute('open')) return;
          try { closeButton.focus({ preventScroll: true }); }
          catch (error) { closeButton.focus(); }
        }, 50);
      }
    }

    function restoreReviewTriggerFocus() {
      var trigger = lastReviewTrigger;
      if (!trigger || typeof trigger.focus !== 'function') return;
      // Native dialog kapandigi anda mobil dock bir frame daha gizli kalabilir.
      // Odak, dock tekrar gorunur olduktan sonra ve kullanici baska bir
      // kontrole gecmediyse geri verilir.
      window.setTimeout(function() {
        if (!trigger.isConnected) return;
        var active = document.activeElement;
        if (active && active !== document.body && active !== document.documentElement) return;
        try { trigger.focus({ preventScroll: true }); }
        catch (error) { trigger.focus(); }
      }, 120);
    }

    function closeReview() {
      if (!review) return;
      if (typeof review.close === 'function' && review.open) review.close();
      else review.removeAttribute('open');
      document.body.classList.remove('bp-dv-modal-open');
      restoreReviewTriggerFocus();
    }

    function scrollToSection(target, focusTarget) {
      closeReview();
      var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (target && typeof target.scrollIntoView === 'function') {
        target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'center' });
      }
      if (focusTarget && typeof focusTarget.focus === 'function') {
        window.setTimeout(function() {
          try { focusTarget.focus({ preventScroll: true }); }
          catch (_) { focusTarget.focus(); }
        }, reduceMotion ? 50 : 350);
      }
    }

    shapeButtons.forEach(function(button) {
      button.addEventListener('click', function() {
        window.setTimeout(function() {
          syncCircleDimensions(true);
          updateSummary();
        }, 0);
      });
    });
    widthInput.addEventListener('input', function() {
      if (shapeSelect.value === 'daire' && !circleSyncLocked) syncCircleDimensions(true);
      scheduleSummary();
    });
    lengthInput.addEventListener('input', scheduleSummary);
    // Capture fazında çapı eşitle: eski Plus listener'ı aynı change olayında
    // 80×100 gibi geçici değeri görüp tam ekran ölçü uyarısı açmamalı.
    shapeSelect.addEventListener('change', function() {
      syncCircleDimensions(true);
      scheduleSummary();
    }, true);
    edgeGroup.addEventListener('change', scheduleSummary);

    // Galeri motoru önizleme metnini yeniden oluşturabildiği için tetikleyiciyi
    // doğrudan bağlamak yerine kökten delege et. Böylece yeni düğme de çalışır.
    root.addEventListener('click', function(event) {
      var trigger = event.target.closest('#bp-dv-change-product');
      if (!trigger || !root.contains(trigger)) return;
      event.preventDefault();
      openPicker();
    });
    if (picker) {
      picker.addEventListener('click', function(event) {
        if (event.target.closest('[data-dv-picker-close]')) {
          event.preventDefault();
          closePicker();
          return;
        }
        if (event.target.closest('.bp-pat')) {
          window.setTimeout(function() {
            updateSelectedProduct();
            closePicker();
          }, 420);
        }
      });
    }

    var backButton = document.getElementById('bp-dv-flow-back');
    if (backButton) {
      backButton.addEventListener('click', function() {
        if (window.history.length > 1) window.history.back();
        else window.location.assign('/collections/all');
      });
    }

    document.addEventListener('click', function(event) {
      var dockButton = event.target.closest('#dv-purchase-dock-button');
      if (!dockButton) return;
      var dock = document.getElementById('dv-purchase-dock');
      if (!dock || dock.getAttribute('data-state') !== 'ready') return;
      event.preventDefault();
      event.stopImmediatePropagation();
      openReview(dockButton);
    }, true);

    if (review) {
      review.addEventListener('click', function(event) {
        if (event.target === review || event.target.closest('[data-dv-review-close]')) {
          event.preventDefault();
          closeReview();
          return;
        }
        var editButton = event.target.closest('[data-dv-edit]');
        if (!editButton) return;
        var key = editButton.getAttribute('data-dv-edit');
        if (key === 'product') {
          closeReview();
          openPicker();
        } else if (key === 'shape') {
          scrollToSection(shapeSection, shapeButtons[0]);
        } else if (key === 'dimensions') {
          scrollToSection(shapeSection, widthInput);
        } else if (key === 'edge') {
          scrollToSection(
            edgeSection,
            edgeGroup.querySelector('input[name="ozel-olcu-edge"]:checked') ||
              edgeGroup.querySelector('input[name="ozel-olcu-edge"]')
          );
        }
      });
      review.addEventListener('close', function() {
        document.body.classList.remove('bp-dv-modal-open');
        restoreReviewTriggerFocus();
      });
    }

    if (reviewConfirm) {
      reviewConfirm.addEventListener('click', function() {
        if (!syncReviewReadiness()) return;
        closeReview();
        sourceButton.click();
      });
    }

    document.addEventListener('keydown', function(event) {
      if (event.key === 'Escape' && picker && !picker.hidden) closePicker();
    });
    document.addEventListener('variant:change', scheduleSummary);
    window.addEventListener('ozel-olcu:pattern-bridge-ready', scheduleSummary);
    window.addEventListener('pageshow', scheduleSummary);

    var summaryObserver = new MutationObserver(scheduleSummary);
    [stockStatus, priceWrap, sourceButton, reviewDock, document.getElementById('bp-desen-name')].forEach(function(node) {
      if (node) summaryObserver.observe(node, { attributes: true, childList: true, subtree: true, characterData: true });
    });

    syncCircleDimensions(true);
    updateSummary();
    window.setTimeout(updateSummary, 450);
    window.setTimeout(updateSummary, 1400);
  });
})();

/* ═══════════════════════════════════════════════════════════════════
   DVP-MODULE v1.0 — Prototip birebir port (2026-07-27)
   Kaynak: tasarim/dolcevita-ozel-olcu-prototip.html
   Motorlara (ozel-olcu-plus.js) dokunmaz; yalnız yerleşim + türev gösterim.
   Veri kaynakları: motor DOM çıktıları + __OZEL_OLCU_CONFIG__ + dock dataset.
   Veri yoksa ilgili bölüm gizli kalır (uydurma değer YOK).
   ═══════════════════════════════════════════════════════════════════ */
(function() {
  'use strict';

  function onReady(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn, { once: true });
    else fn();
  }

  onReady(function initDvpProtoLayer() {
    var root = document.getElementById('banner-product');
    if (!root || root.getAttribute('data-dv-order-flow') !== 'visual-v3') return;
    if (root.getAttribute('data-dvp-mounted') === 'true') return;
    root.setAttribute('data-dvp-mounted', 'true');

    var $ = function(id) { return document.getElementById(id); };
    var widthInput = $('ozel-olcu-width');
    var lengthInput = $('ozel-olcu-length');
    var shapeSelect = $('ozel-olcu-shape');
    var priceWrap = $('ozel-olcu-price-display');
    var priceEl = $('ozel-olcu-price');
    var compareEl = $('ozel-olcu-compare-price');
    var detailEl = $('ozel-olcu-price-detail');
    var stockEl = $('ozel-olcu-stock-status');
    var sourceButton = $('ozel-olcu-add-to-cart');
    var errorEl = $('ozel-olcu-error');
    var dock = null; // sonradan oluşur
    if (!widthInput || !lengthInput || !shapeSelect || !priceWrap || !sourceButton) return;

    /* ---------- 0) Kart-3 iskeleti + chips + yerleşim taşımaları ---------- */
    var priceBody = $('dvp-card-price-body');
    if (priceBody && !priceBody.childElementCount) {
      priceBody.innerHTML =
        '<div class="dvp-empty-price" id="dvp-empty-price">Fiyatı görmek için <b>en ve boy</b> gir — anında hesaplanır.</div>' +
        '<div class="dvp-breakdown" id="dvp-breakdown" style="display:none">' +
          '<div id="dvp-engine-price-slot"></div>' +
          '<div class="dvp-brow" id="dvp-b-cartrow" hidden><span>Sepette ek indirim <span class="dvp-tag" id="dvp-b-carttag"></span></span><b id="dvp-b-cart">—</b></div>' +
          '<div class="dvp-final" id="dvp-final" hidden><div class="dvp-final-cap">Sepette ödeyeceğin<small>KDV ve kargo dahil</small></div><div class="dvp-final-right"><div class="dvp-bigprice" id="dvp-bigprice">—</div><div class="dvp-taksit" id="dvp-taksit"></div></div></div>' +
        '</div>' +
        '<div id="dvp-deliv-slot"></div><div id="dvp-cta-slot"></div>' +
        '<div class="dvp-trust"><span>\uD83D\uDD12 Güvenli ödeme</span><span>\uD83D\uDCB3 6 taksit</span><span>\uD83E\uDD16 Robot süpürgeye uygun</span><span>\uD83C\uDDF9\uD83C\uDDF7 Türkiye üretimi</span></div>' +
        '<div class="dvp-iade-mini">Kişiye özel kesildiği için üretim başladıktan sonra iade edilemez; fabrikasyon hataları her zaman güvence altındadır.</div>';
    }
    var chipsSlot = $('dvp-chips-slot');
    if (chipsSlot && !chipsSlot.childElementCount) {
      chipsSlot.innerHTML = '<div class="dvp-chips" id="dvp-chips">' +
        '<button type="button" class="dvp-chip" data-w="80" data-l="150">80 × 150</button>' +
        '<button type="button" class="dvp-chip" data-w="100" data-l="200">100 × 200</button>' +
        '<button type="button" class="dvp-chip" data-w="120" data-l="180">120 × 180</button>' +
        '<button type="button" class="dvp-chip" data-w="160" data-l="230">160 × 230 <small>popüler</small></button>' +
        '<button type="button" class="dvp-chip" data-w="200" data-l="300">200 × 300</button></div>';
    }
    var gallery = root.querySelector('.bp-gallery');
    var mainImageEl = $('bp-main-image');
    var thumbsEl = $('bp-thumbs');
    if (gallery && mainImageEl && !$('dvp-stage-tabs')) {
      var tabsEl = document.createElement('div');
      tabsEl.className = 'dvp-stage-tabs'; tabsEl.id = 'dvp-stage-tabs'; tabsEl.hidden = true;
      tabsEl.innerHTML = '<button type="button" class="dvp-stage-tab on" id="dvp-tab-photo">Fotoğraf</button>' +
        '<button type="button" class="dvp-stage-tab" id="dvp-tab-room">\uD83D\uDCD0 Ölçekli Önizleme</button>';
      gallery.insertBefore(tabsEl, mainImageEl);
      var roomDiv = document.createElement('div');
      roomDiv.className = 'dvp-room'; roomDiv.id = 'dvp-room'; roomDiv.hidden = true;
      roomDiv.innerHTML = '<div class="dvp-room-hint">Halınız gerçek oranlarla, 220 cm\'lik koltuğa göre ölçeklendi</div>' +
        '<div class="dvp-sofa" id="dvp-sofa"><svg id="dvp-sofa-svg" width="264" height="108" viewBox="0 0 264 108" fill="none" aria-hidden="true"><rect x="2" y="2" width="260" height="104" rx="18" fill="#e3dccf"/><rect x="14" y="14" width="112" height="56" rx="10" fill="#d5ccba"/><rect x="138" y="14" width="112" height="56" rx="10" fill="#d5ccba"/><rect x="14" y="76" width="236" height="20" rx="8" fill="#cdc3ae"/></svg><span class="dvp-sofa-cap">koltuk · 220 cm</span></div>' +
        '<div class="dvp-rug" id="dvp-rug"><div class="dvp-fr t"></div><div class="dvp-fr b"></div></div>' +
        '<div class="dvp-dim w" id="dvp-dim-w"><span class="ln"></span><span class="val" id="dvp-dim-wv">— cm</span><span class="ln"></span></div>' +
        '<div class="dvp-dim h" id="dvp-dim-h"><span class="ln"></span><span class="val" id="dvp-dim-hv">— cm</span><span class="ln"></span></div>';
      if (thumbsEl) gallery.insertBefore(roomDiv, thumbsEl);
      else gallery.appendChild(roomDiv);
    }
    var accWrap = document.querySelector('.bp-accordion');
    if (accWrap && !$('dvp-bento-sec')) {
      var bentoSec = document.createElement('div');
      bentoSec.className = 'dvp-bento-sec'; bentoSec.id = 'dvp-bento-sec'; bentoSec.hidden = true;
      bentoSec.innerHTML = '<h2 class="dvp-bento-h">Bir bakışta</h2><div class="dvp-bento" id="dvp-bento"></div>';
      accWrap.parentNode.insertBefore(bentoSec, accWrap);
    }
    var engineSlot = $('dvp-engine-price-slot');
    if (engineSlot && priceWrap) engineSlot.appendChild(priceWrap);
    var ctaSlot = $('dvp-cta-slot');
    if (ctaSlot) {
      ctaSlot.appendChild(sourceButton);
      if (errorEl) ctaSlot.appendChild(errorEl);
    }
    var delivSlot = $('dvp-deliv-slot');
    var timeline = $('bp-delivery');
    if (delivSlot && timeline) delivSlot.appendChild(timeline);

    /* ---------- 1) Kicker + m² chip + desen butonu ---------- */
    function cfg() { return window.__OZEL_OLCU_CONFIG__ || null; }
    function fmtInt(n) { return Number(n).toLocaleString('tr-TR', { maximumFractionDigits: 0 }); }
    function refreshKicker() {
      var c = cfg();
      var el = $('dvp-kicker-text');
      if (el && c && (c.qualityCode || c.patternCode)) {
        var q = String(c.qualityCode || '').toLocaleUpperCase('tr-TR');
        var p = String(c.patternCode || '').toLocaleUpperCase('tr-TR');
        el.textContent = (q ? q + ' KOLEKSİYONU' : '') + (q && p ? ' · ' : '') + p;
      }
      var sw = root.querySelector('.dvp-kicker-sw');
      if (sw && c && c.patternImage) sw.style.backgroundImage = 'url("' + c.patternImage + '")';
      var chip = $('dvp-m2chip');
      if (chip) {
        if (c && Number(c.m2Price) > 0) {
          chip.textContent = fmtInt(c.m2Price) + ' TL/m²';
          chip.hidden = false;
        } else chip.hidden = true;
      }
    }
    var desenBtn = $('dvp-desen-btn');
    if (desenBtn) desenBtn.addEventListener('click', function() {
      var t = $('bp-dv-change-product');
      if (t) t.click();
    });

    /* ---------- 2) Stepper butonları ---------- */
    function injectStepper(input, step) {
      var header = input.closest('.bp-dsc__header');
      if (!header || header.querySelector('.dvp-stepbtn')) return;
      function mk(delta, txt) {
        var b = document.createElement('button');
        b.type = 'button'; b.className = 'dvp-stepbtn'; b.textContent = txt;
        b.setAttribute('aria-label', (delta > 0 ? 'Artır ' : 'Azalt ') + step);
        b.addEventListener('click', function() {
          var min = parseInt(input.min, 10) || 50;
          var max = parseInt(input.max, 10) || 600;
          var v = parseInt(input.value, 10);
          if (!v) v = delta > 0 ? min : min;
          else v = Math.max(min, Math.min(max, v + delta));
          input.value = String(v);
          clearChips();
          input.dispatchEvent(new Event('input', { bubbles: true }));
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
        return b;
      }
      header.insertBefore(mk(-step, '−'), input);
      var unit = header.querySelector('.bp-dsc__unit');
      header.insertBefore(mk(step, '+'), unit ? unit.nextSibling : null);
    }
    injectStepper(widthInput, 10);
    injectStepper(lengthInput, 10);

    /* ---------- 3) Hazır ölçü chip'leri ---------- */
    function clearChips() {
      var on = root.querySelectorAll('.dvp-chip.on');
      for (var i = 0; i < on.length; i++) on[i].classList.remove('on');
    }
    var chipsWrap = $('dvp-chips');
    if (chipsWrap) {
      chipsWrap.addEventListener('click', function(e) {
        var chip = e.target.closest('.dvp-chip');
        if (!chip) return;
        clearChips();
        chip.classList.add('on');
        widthInput.value = chip.getAttribute('data-w');
        lengthInput.value = chip.getAttribute('data-l');
        widthInput.dispatchEvent(new Event('input', { bubbles: true }));
        widthInput.dispatchEvent(new Event('change', { bubbles: true }));
        lengthInput.dispatchEvent(new Event('input', { bubbles: true }));
        lengthInput.dispatchEvent(new Event('change', { bubbles: true }));
      });
      var markManual = function(ev) { if (ev.isTrusted) clearChips(); };
      widthInput.addEventListener('input', markManual);
      lengthInput.addEventListener('input', markManual);
    }

    /* ---------- 4) Şekil + kenar ikonları ---------- */
    var SHAPE_ICONS = {
      dikdortgen: '<svg viewBox="0 0 34 26" fill="none"><rect x="3" y="2" width="28" height="22" rx="2" stroke="currentColor" stroke-width="2"/></svg>',
      daire: '<svg viewBox="0 0 34 26" fill="none"><circle cx="17" cy="13" r="11" stroke="currentColor" stroke-width="2"/></svg>',
      oval: '<svg viewBox="0 0 34 26" fill="none"><ellipse cx="17" cy="13" rx="14" ry="10" stroke="currentColor" stroke-width="2"/></svg>',
      amorf: '<svg viewBox="0 0 34 26" fill="none"><path d="M17 3c6 0 13 3 13 9s-5 11-12 11S4 20 4 13 11 3 17 3z" stroke="currentColor" stroke-width="2"/></svg>'
    };
    var EDGE_ICONS = {
      sacak: '<svg viewBox="0 0 34 26" fill="none"><rect x="3" y="6" width="28" height="14" stroke="currentColor" stroke-width="2"/><path d="M5 6V2M10 6V2M15 6V2M20 6V2M25 6V2M29 6V2M5 24v-4M10 24v-4M15 24v-4M20 24v-4M25 24v-4M29 24v-4" stroke="currentColor" stroke-width="1.4"/></svg>',
      overlok: '<svg viewBox="0 0 34 26" fill="none"><rect x="3" y="4" width="28" height="18" stroke="currentColor" stroke-width="3.4"/></svg>',
      biye: '<svg viewBox="0 0 34 26" fill="none"><rect x="3" y="4" width="28" height="18" stroke="currentColor" stroke-width="2"/><rect x="7" y="8" width="20" height="10" stroke="currentColor" stroke-width="1.2"/></svg>',
      bordur: '<svg viewBox="0 0 34 26" fill="none"><rect x="3" y="3" width="28" height="20" stroke="currentColor" stroke-width="2"/><rect x="9" y="8" width="16" height="10" fill="currentColor" opacity=".25"/></svg>'
    };
    root.querySelectorAll('#bp-shape-btns .bp-shape-btn').forEach(function(b) {
      var key = b.getAttribute('data-shape');
      if (SHAPE_ICONS[key] && !b.querySelector('.dvp-segico')) {
        var s = document.createElement('span');
        s.className = 'dvp-segico'; s.setAttribute('aria-hidden', 'true');
        s.innerHTML = SHAPE_ICONS[key];
        b.insertBefore(s, b.firstChild);
      }
    });
    root.querySelectorAll('#ozel-olcu-edge-type [data-edge]').forEach(function(l) {
      var key = l.getAttribute('data-edge');
      if (EDGE_ICONS[key] && !l.querySelector('.dvp-segico')) {
        var s = document.createElement('span');
        s.className = 'dvp-segico'; s.setAttribute('aria-hidden', 'true');
        s.innerHTML = EDGE_ICONS[key];
        l.insertBefore(s, l.firstChild);
      }
    });

    /* ---------- 5) Fiyat türevleri ---------- */
    function parseTL(text) {
      var t = String(text || '').replace(/[^\d,.]/g, '');
      if (!t) return NaN;
      t = t.replace(/\./g, '').replace(',', '.');
      var n = parseFloat(t);
      return isFinite(n) ? n : NaN;
    }
    function formatTL(amount) {
      return new Intl.NumberFormat('tr-TR', { style: 'currency', currency: 'TRY' }).format(amount);
    }
    function engineVisible() {
      return priceWrap && priceWrap.style.display !== 'none' && priceWrap.style.display !== '';
    }
    var lastCartPct = 0;
    var lastCartPctAt = 0;
    function getCartPercent() {
      if (!dock) dock = $('dv-purchase-dock');
      if (!dock) return 0;
      var v = parseFloat(String(dock.getAttribute('data-cart-discount-percent') || '').replace(',', '.'));
      if (isFinite(v) && v > 0) {
        lastCartPct = v;
        lastCartPctAt = Date.now();
        return v;
      }
      /* eligibility yenilenirken kısa süreli boşlukta son doğrulanmış değeri koru (5 dk) */
      if (lastCartPct > 0 && Date.now() - lastCartPctAt < 300000) return lastCartPct;
      return 0;
    }

    var lastBig = 0;
    function animBig(el, to) {
      el.textContent = formatTL(to);
      lastBig = to;
    }

    /* ---------- 6) Ölçekli önizleme ---------- */
    var stageTabs = $('dvp-stage-tabs');
    var tabPhoto = $('dvp-tab-photo');
    var tabRoom = $('dvp-tab-room');
    var roomEl = $('dvp-room');
    var mainImage = $('bp-main-image');
    var rugEl = $('dvp-rug');
    var roomShownOnce = false;

    function showView(which) {
      if (!stageTabs || !roomEl || !mainImage) return;
      var photo = which === 'photo';
      tabPhoto.classList.toggle('on', photo);
      tabRoom.classList.toggle('on', !photo);
      mainImage.style.display = photo ? '' : 'none';
      roomEl.hidden = photo;
      if (!photo) renderRoom();
    }
    if (stageTabs && roomEl) {
      stageTabs.hidden = false;
      tabPhoto.addEventListener('click', function() { showView('photo'); });
      tabRoom.addEventListener('click', function() { showView('room'); });
      var thumbs = $('bp-thumbs');
      if (thumbs) thumbs.addEventListener('click', function() { showView('photo'); });
    }

    function getRugImageSrc() {
      var img = $('bp-product-img');
      var c = cfg();
      return (img && (img.currentSrc || img.src)) || (c && c.patternImage) || '';
    }

    function renderRoom() {
      if (!roomEl || roomEl.hidden || !rugEl) return;
      var W = roomEl.clientWidth || 600;
      var shape = shapeSelect.value;
      var w = parseInt(widthInput.value, 10) || 0;
      var l = parseInt(lengthInput.value, 10) || 0;
      var effL = shape === 'daire' ? w : l;
      var valid = w >= 50 && w <= 200 && effL >= 50 && effL <= 600;
      var rw, rh;
      if (!valid) { rw = 180; rh = 260; }
      else {
        var roomCm = Math.max(320, w * 1.35, 260);
        var pxCm = (W * 0.86) / roomCm;
        var sofa = $('dvp-sofa-svg');
        if (sofa) {
          var sw = 220 * pxCm;
          sofa.setAttribute('width', String(Math.round(sw)));
          sofa.setAttribute('height', String(Math.round(sw * 108 / 264)));
        }
        rw = w * pxCm; rh = effL * pxCm;
        var maxH = roomEl.clientHeight - 155;
        if (rh > maxH) { var k = maxH / rh; rw *= k; rh *= k; }
      }
      rugEl.style.width = Math.round(rw) + 'px';
      rugEl.style.height = Math.round(rh) + 'px';
      rugEl.style.marginLeft = Math.round(-rw / 2) + 'px';
      var src = getRugImageSrc();
      if (src) rugEl.style.backgroundImage = 'url("' + src.replace(/"/g, '%22') + '")';
      var isRect = shape === 'dikdortgen' || shape === 'amorf';
      rugEl.classList.toggle('doku', !isRect);
      rugEl.style.borderRadius = isRect ? '3px' : '50%';
      var edgeChecked = root.querySelector('input[name="ozel-olcu-edge"]:checked');
      var edgeVal = edgeChecked ? edgeChecked.value : '';
      rugEl.classList.toggle('no-fr', !(edgeVal === 'sacak' && isRect));
      rugEl.classList.toggle('ov-edge', edgeVal === 'overlok');
      var top = 100;
      var cx = W / 2;
      var dw = $('dvp-dim-w'), dh = $('dvp-dim-h');
      if (dw) {
        dw.style.left = cx + 'px';
        dw.style.top = (top + rh + 10) + 'px';
        dw.style.width = Math.max(90, rw) + 'px';
      }
      if (dh) {
        dh.style.left = (cx + rw / 2 + 14) + 'px';
        dh.style.top = top + 'px';
        dh.style.height = rh + 'px';
      }
      var wv = $('dvp-dim-wv'), hv = $('dvp-dim-hv');
      if (wv) wv.textContent = valid ? (w + ' cm') : '— cm';
      if (hv) hv.textContent = valid ? (effL + ' cm') : '— cm';
    }

    /* ---------- 7) Ana senkron ---------- */
    var syncQueued = 0;
    function scheduleUpdate() {
      if (syncQueued) return;
      syncQueued = requestAnimationFrame(function() { syncQueued = 0; updateAll(); });
    }

    function updateAll() {
      var visible = engineVisible();
      var emptyEl = $('dvp-empty-price');
      var sumline = $('bp-dv-order-summary');
      var breakdown = $('dvp-breakdown');
      var doneSize = $('dvp-done-size');
      if (emptyEl) emptyEl.style.display = visible ? 'none' : '';
      if (sumline) sumline.style.display = visible ? '' : 'none';
      if (breakdown) breakdown.style.display = visible ? '' : 'none';
      var bentoWrap = $('dvp-bento-sec'); /* accordion taşınırsa bento konumu korunur */
      if (doneSize) doneSize.classList.toggle('on', visible);

      /* alan (m²) — motor detail metninden */
      var areaEl = $('dvp-sum-area');
      if (areaEl) {
        var m = /([\d.,]+)\s*m²/.exec(String(detailEl && detailEl.textContent || ''));
        areaEl.textContent = m ? (m[1] + ' m²') : '—';
      }

      /* rulo yuvarlama notu — istek ≠ üretim eni */
      var rollNote = $('dvp-rollnote');
      if (rollNote) {
        var reqW = parseInt(widthInput.value, 10) || 0;
        var prod = /(\d+)\s*cm\s*×/.exec(String(detailEl && detailEl.textContent || ''));
        var prodW = prod ? parseInt(prod[1], 10) : 0;
        if (visible && reqW && prodW && prodW !== reqW) {
          rollNote.innerHTML = '<span aria-hidden="true">&#128161;</span><span><b>' + reqW +
            ' cm</b> en için halın <b>' + prodW + ' cm rulodan</b> kesilir; fiyat ' + prodW +
            ' cm genişlik üzerinden hesaplanır. İstersen eni <b>' + prodW + ' cm</b> yapabilirsin — fiyat aynı kalır.</span>';
          rollNote.hidden = false;
        } else rollNote.hidden = true;
      }

      /* fiyat türevleri */
      var price = visible ? parseTL(priceEl && priceEl.textContent) : NaN;
      var compare = visible ? parseTL(compareEl && compareEl.textContent) : NaN;
      if (priceEl) {
        var tag = '';
        if (isFinite(price) && isFinite(compare) && compare > price) {
          tag = '  ·  %' + Math.round((1 - price / compare) * 100) + ' indirim';
        }
        priceEl.setAttribute('data-dvp-tag', tag);
      }
      var cartPct = getCartPercent();
      var cartRow = $('dvp-b-cartrow');
      var finalWrap = $('dvp-final');
      var bigEl = $('dvp-bigprice');
      var taksitEl = $('dvp-taksit');
      var reviewFinal = $('dvp-review-final');
      var reviewCaps = $('dvp-review-caps');
      if (visible && isFinite(price)) {
        var finalPrice = cartPct > 0 ? price * (1 - cartPct / 100) : price;
        if (cartRow) {
          if (cartPct > 0) {
            cartRow.hidden = false;
            var tagEl = $('dvp-b-carttag');
            if (tagEl) tagEl.textContent = '%' + String(cartPct).replace('.', ',');
            var amtEl = $('dvp-b-cart');
            if (amtEl) amtEl.textContent = '−' + formatTL(price - finalPrice);
          } else cartRow.hidden = true;
        }
        if (finalWrap) finalWrap.hidden = false;
        if (bigEl) animBig(bigEl, finalPrice);
        if (taksitEl) taksitEl.textContent = '6 taksitte ayda ' + formatTL(finalPrice / 6);
        if (reviewFinal) reviewFinal.textContent = formatTL(finalPrice);
        if (reviewCaps) {
          var prodPct = (isFinite(compare) && compare > price) ? Math.round((1 - price / compare) * 100) : 0;
          var capsBits = [];
          if (prodPct > 0) capsBits.push('%' + prodPct + ' ürün');
          if (cartPct > 0) capsBits.push('sepette %' + String(cartPct).replace('.', ','));
          reviewCaps.textContent = capsBits.length ? capsBits.join(' + ') + ' indirimle' : '';
        }
      } else {
        if (cartRow) cartRow.hidden = true;
        if (finalWrap) finalWrap.hidden = true;
        if (reviewFinal) reviewFinal.textContent = '—';
        if (reviewCaps) reviewCaps.textContent = '';
      }

      /* ölçekli önizlemeye otomatik geçiş (ilk geçerli ölçüde bir kez) */
      var w = parseInt(widthInput.value, 10) || 0;
      var l = parseInt(lengthInput.value, 10) || 0;
      var effL = shapeSelect.value === 'daire' ? w : l;
      if (!roomShownOnce && stageTabs && !stageTabs.hidden && w >= 50 && effL >= 50 && shapeSelect.value !== 'amorf') {
        roomShownOnce = true;
        showView('room');
      }
      if (roomEl && !roomEl.hidden) renderRoom();
      refreshKicker();
    }

    /* ---------- 8) Alt bölüm: bento + koleksiyon şeridi + akordeon (prototip birebir) ---------- */
    function getDescText() {
      var accs = document.querySelectorAll('.bp-accordion .bp-acc-item');
      for (var i = 0; i < accs.length; i++) {
        var sm = accs[i].querySelector('summary');
        var t = sm ? sm.textContent : '';
        if (t.indexOf('Açıklama') !== -1) return String(accs[i].textContent || '');
      }
      return '';
    }
    function buildBento() {
      var sec = $('dvp-bento-sec');
      var grid = $('dvp-bento');
      if (!sec || !grid) return;
      var descText = getDescText();
      function pick(re) {
        var m = re.exec(descText);
        return m ? m[1].replace(/\s+/g, ' ').trim() : '';
      }
      /* satır bazlı: iki nokta sonrası, satır/etiket sonuna kadar */
      var uretim = pick(/Üretim Şekli\s*:\s*([^\n<]{2,60})/i);
      var iplik = pick(/İplik Türü\s*:\s*([^\n<]{2,60})/i);
      var hav = pick(/Hav Yüksekliği\s*:\s*([^\n<]{1,40})/i);
      var taban = pick(/Taban\s*:\s*([^\n<]{2,40})/i);
      var items = [];
      if (iplik) items.push(['\uD83E\uDDF5', 'İplik', iplik]);
      if (hav) items.push(['\uD83D\uDCCF', 'Hav', hav]);
      if (taban) items.push(['\uD83E\uDEA1', 'Taban', taban]);
      if (uretim) items.push(['\uD83C\uDFED', 'Üretim', uretim]);
      items.push(['\uD83E\uDD16', 'Robot süpürge', 'Uygun']);
      var wMin = String(Math.max(50, parseInt(widthInput.min, 10) || 50)), wMax = widthInput.max || '200', lMax = lengthInput.max || '600';
      items.push(['\u2702\uFE0F', 'Özel ölçü', wMin + '–' + wMax + ' × ' + lMax + ' cm']);
      var html = '';
      for (var j = 0; j < items.length; j++) {
        html += '<div class="dvp-bcard"><span class="bic" aria-hidden="true">' + items[j][0] +
          '</span><span class="bl">' + items[j][1] + '</span><span class="bv">' + items[j][2] + '</span></div>';
      }
      grid.innerHTML = html;
      var c = cfg();
      var qname = c && c.qualityCode ? String(c.qualityCode).charAt(0).toLocaleUpperCase('tr-TR') + String(c.qualityCode).slice(1) : '';
      var pat = c && c.patternCode ? String(c.patternCode).split(' ')[0] : '';
      sec.querySelector('.dvp-bento-h').textContent = 'Bir bakışta' + (qname ? ' ' + qname + (pat ? ' ' + pat : '') : '');
      sec.hidden = false;
    }

    function buildCollectionStrip() {
      var c = cfg();
      var all = window.__ALL_CONFIGS__ || {};
      if (all.products) all = all.products;
      if (!c || !c.qualityCode) return;
      var strip = $('dvp-coll-sec');
      if (!strip) {
        var acc = document.querySelector('.bp-accordion');
        if (!acc) return;
        strip = document.createElement('div');
        strip.id = 'dvp-coll-sec';
        strip.className = 'dvp-coll-sec';
        strip.innerHTML = '<h2 class="dvp-bento-h">Aynı koleksiyondan desenler</h2><div class="dvp-coll" id="dvp-coll"></div>';
        acc.parentNode.insertBefore(strip, acc);
      }
      var wrap = $('dvp-coll');
      if (!wrap) return;
      var q = String(c.qualityCode).toLowerCase();
      var cards = '';
      var count = 0;
      var keys = Object.keys(all);
      for (var i = 0; i < keys.length; i++) {
        var cf = all[keys[i]];
        if (!cf || String(cf.qualityCode || '').toLowerCase() !== q) continue;
        var isCur = cf.patternCode === c.patternCode;
        var img = cf.patternImage ? String(cf.patternImage).replace(/"/g, '%22') : '';
        var m2 = Number(cf.m2Price) > 0 ? fmtInt(cf.m2Price) + ' TL/m²' : '';
        var href = cf.shopifyHandle ? '/products/' + cf.shopifyHandle : '';
        cards += '<a class="dvp-ccard' + (isCur ? ' on' : '') + '"' + (href && !isCur ? ' href="' + href + '"' : '') + '>' +
          '<span class="ci"' + (img ? ' style="background-image:url(\'' + img + '\')"' : (cf.patternBg ? ' style="background:' + cf.patternBg + '"' : '')) + '></span>' +
          '<span class="cn">' + String(cf.patternCode || cf.name || '').slice(0, 24) + '</span>' +
          '<span class="cp">' + (isCur ? 'Bu sayfa' : m2) + '</span></a>';
        count++;
      }
      if (count < 2) { strip.style.display = 'none'; return; }
      wrap.innerHTML = cards;
      strip.style.display = '';
    }

    function buildQualityStrip() {
      var c = cfg();
      var all = window.__ALL_CONFIGS__ || {};
      if (all.products) all = all.products;
      if (!c) return;
      var cur = String(c.qualityCode || '').toLowerCase();
      var groups = {};
      var keys = Object.keys(all);
      for (var i = 0; i < keys.length; i++) {
        var cf = all[keys[i]];
        if (!cf || !cf.qualityCode || !cf.shopifyHandle) continue;
        var q = String(cf.qualityCode).toLowerCase();
        if (q === cur) continue;
        var g = groups[q];
        if (!g) {
          g = groups[q] = { name: String(cf.qualityCode), img: '', bg: '', handle: '', count: 0, minM2: 0, firstPat: '\uffff' };
        }
        g.count++;
        var m2 = Number(cf.m2Price) || 0;
        if (m2 > 0 && (g.minM2 === 0 || m2 < g.minM2)) g.minM2 = m2;
        var pat = String(cf.patternCode || keys[i]);
        if (pat < g.firstPat) {
          g.firstPat = pat;
          g.img = cf.patternImage || '';
          g.bg = cf.patternBg || '';
          g.handle = cf.shopifyHandle;
        }
      }
      var qKeys = Object.keys(groups);
      if (!qKeys.length) return;
      qKeys.sort();
      var strip = $('dvp-qual-sec');
      if (!strip) {
        var acc = document.querySelector('.bp-accordion');
        if (!acc) return;
        strip = document.createElement('div');
        strip.id = 'dvp-qual-sec';
        strip.className = 'dvp-coll-sec';
        strip.innerHTML = '<h2 class="dvp-bento-h">Kesme yapılan diğer kaliteler</h2><div class="dvp-coll" id="dvp-qual"></div>';
        acc.parentNode.insertBefore(strip, acc);
      }
      var wrap = $('dvp-qual');
      if (!wrap) return;
      var cards = '';
      for (var k = 0; k < qKeys.length; k++) {
        var g2 = groups[qKeys[k]];
        var nm = g2.name.replace(/(^|\s)\S/g, function(ch) { return ch.toLocaleUpperCase('tr-TR'); });
        var sub = g2.count + ' desen' + (g2.minM2 > 0 ? ' · ' + fmtInt(g2.minM2) + ' TL/m²' : '');
        var img = g2.img ? String(g2.img).replace(/"/g, '%22') : '';
        cards += '<a class="dvp-ccard dvp-qcard" href="/products/' + g2.handle + '">' +
          '<span class="ci"' + (img ? ' style="background-image:url(\'' + img + '\')"' : (g2.bg ? ' style="background:' + g2.bg + '"' : '')) + '></span>' +
          '<span class="cn">' + nm + '</span><span class="cp">' + sub + '</span></a>';
      }
      wrap.innerHTML = cards;
    }

    var ACC_META = {
      'Açıklama': ['\uD83D\uDCD6', 'Ürün Açıklaması'],
      'Halı Kullanım Kılavuzu': ['\uD83E\uDDFC', 'Bakım ve Kullanım'],
      'Kargo Bilgilendirmesi': ['\uD83D\uDE9A', 'Kargo ve Teslimat'],
      'Ölçü Detayları': ['\uD83D\uDCD0', 'Ölçü Detayları'],
      'Teknik Özellikler': ['\uD83E\uDDF7', 'Teknik Özellikler']
    };
    function restyleAccordions() {
      var acc = document.querySelector('.bp-accordion');
      if (!acc || acc.getAttribute('data-dvp-done') === 'true') return;
      acc.setAttribute('data-dvp-done', 'true');
      /* başlık */
      if (!$('dvp-acc-title')) {
        var h = document.createElement('h2');
        h.id = 'dvp-acc-title';
        h.className = 'dvp-bento-h';
        h.textContent = 'Merak ettiklerin';
        acc.insertBefore(h, acc.firstChild);
      }
      var items = acc.querySelectorAll('.bp-acc-item');
      for (var i = 0; i < items.length; i++) {
        var sm = items[i].querySelector('summary');
        if (!sm) continue;
        var t = sm.textContent.trim();
        if (t === 'Diğer Şekil Seçenekleri') { items[i].style.display = 'none'; continue; }
        var meta = ACC_META[t];
        if (meta && !sm.querySelector('.dvp-aic')) {
          sm.innerHTML = '<span class="dvp-aic" aria-hidden="true">' + meta[0] + '</span><span class="dvp-atx">' + meta[1] + '</span><span class="dvp-achev" aria-hidden="true">\u25BE</span>';
        }
        /* Açıklama içindeki tekrar iade cümlesini gizle */
        if (t === 'Açıklama') {
          var walker = items[i].querySelectorAll('.bp-acc-content p, .bp-acc-content div, .bp-acc-content span');
          for (var w = 0; w < walker.length; w++) {
            var tx = (walker[w].textContent || '').trim();
            if (tx.indexOf('Bu ürün, kişiye özel olarak üretilmektedir') === 0 && tx.length < 260) {
              walker[w].style.display = 'none';
              break;
            }
          }
        }
      }
      /* Ölçü Rehberi + İade akordeonları (prototip) */
      function addAcc(id, icon, title, bodyHtml, first) {
        if (document.getElementById(id)) return;
        var d = document.createElement('details');
        d.className = 'bp-acc-item';
        d.id = id;
        d.innerHTML = '<summary><span class="dvp-aic" aria-hidden="true">' + icon + '</span><span class="dvp-atx">' + title + '</span><span class="dvp-achev" aria-hidden="true">\u25BE</span></summary><div class="bp-acc-content">' + bodyHtml + '</div>';
        var anchor = null;
        if (first) {
          var all = acc.querySelectorAll('.bp-acc-item');
          for (var a = 0; a < all.length; a++) {
            var st = all[a].querySelector('summary');
            var tt = st ? st.textContent : '';
            if (tt.indexOf('Açıklama') !== -1 || tt.indexOf('Ürün Açıklaması') !== -1) { anchor = all[a]; break; }
          }
        }
        if (anchor) acc.insertBefore(d, anchor.nextSibling);
        else acc.appendChild(d);
      }
      addAcc('dvp-acc-guide', '\uD83D\uDCD0', 'Ölçü Rehberi — doğru ölçü nasıl alınır?',
        '<p class="dvp-mini-t">Nasıl ölçmelisin?</p><ul>' +
        '<li>Halıyı sereceğin alanın enini ve boyunu duvardan duvara ölç, her kenardan 25–40 cm boşluk bırak.</li>' +
        '<li>Koltuğun ön ayakları halının üzerine gelirse oda daha derli toplu görünür.</li></ul>' +
        '<p class="dvp-mini-t">Üretim payları</p><ul>' +
        '<li>Halılar rulodan kesilir: en, rulo genişliklerinden (80 / 100 / 120 / 160 / 200 cm) faturalanır; boy serbesttir.</li>' +
        '<li>Doğal elyaf nedeniyle ende %±3–4, boyda %±1–2 fark olabilir.</li></ul>' +
        '<table class="dvp-gtable"><tr><th>Mekân</th><th>Önerilen ölçü</th></tr>' +
        '<tr><td>Koltuk önü / salon</td><td>160 × 230 – 200 × 300</td></tr>' +
        '<tr><td>Yatak yanı</td><td>80 × 150 – 100 × 200</td></tr>' +
        '<tr><td>Mutfak / koridor</td><td>80 × 200 – 100 × 300</td></tr></table>', true);
      addAcc('dvp-acc-iade', '\u21A9\uFE0F', 'Özel Ölçü ve İade Koşulları',
        '<p><b>Özel ölçü halılar kişiye özel kesildiği için</b> ilgili mevzuat gereği iade ve değişime kapalıdır. ' +
        '<b>Fabrikasyon hataları bu kapsamın dışındadır</b> — üretim kaynaklı her sorunda halınız yeniden üretilir veya ücret iadesi yapılır.</p>' +
        '<p>Standart (hazır ölçü) ürünlerde teslimden itibaren 14 gün içinde iade hakkınız saklıdır. İade sürecini <a href="/pages/iade-degisim">iade sayfamızdan</a> başlatabilirsiniz.</p>', false);
      /* sarmalayıcı: bento → şerit → akordeon */
      var wrap = document.getElementById('dvp-below');
      if (!wrap) {
        wrap = document.createElement('div');
        wrap.id = 'dvp-below';
        wrap.className = 'dvp-below';
        acc.parentNode.insertBefore(wrap, acc);
      }
      var bento = $('dvp-bento-sec');
      var coll = $('dvp-coll-sec');
      var qual = $('dvp-qual-sec');
      if (bento) wrap.appendChild(bento);
      if (coll) wrap.appendChild(coll);
      if (qual) wrap.appendChild(qual);
      wrap.appendChild(acc);
    }

    function dedupeAccordions() {
      var seen = {};
      var items = document.querySelectorAll('.bp-accordion .bp-acc-item, details.bp-acc-item');
      for (var i = 0; i < items.length; i++) {
        var sm = items[i].querySelector('summary');
        var key = sm ? sm.textContent.replace(/\s+/g, ' ').trim() : '';
        if (!key) continue;
        if (seen[key]) items[i].style.display = 'none';
        else seen[key] = true;
      }
    }

    /* ---------- 9) Gözlemciler ---------- */
    var obs = new MutationObserver(scheduleUpdate);
    if (priceWrap) obs.observe(priceWrap, { attributes: true, childList: true, subtree: true, characterData: true });
    if (stockEl) obs.observe(stockEl, { attributes: true, childList: true, subtree: true, characterData: true });
    var img = $('bp-product-img');
    if (img) obs.observe(img, { attributes: true, attributeFilter: ['src', 'srcset'] });
    function watchDock() {
      var d = $('dv-purchase-dock');
      if (d) {
        dock = d;
        obs.observe(d, { attributes: true, attributeFilter: ['data-cart-discount-percent', 'data-product-discount-percent', 'data-state'] });
      } else setTimeout(watchDock, 400);
    }
    watchDock();

    ['input', 'change'].forEach(function(ev) {
      widthInput.addEventListener(ev, scheduleUpdate);
      lengthInput.addEventListener(ev, scheduleUpdate);
      shapeSelect.addEventListener(ev, scheduleUpdate);
    });
    var edgeGroup = $('ozel-olcu-edge-type');
    if (edgeGroup) edgeGroup.addEventListener('change', scheduleUpdate);
    var reviewDlg = $('bp-dv-order-review');
    if (reviewDlg) obs.observe(reviewDlg, { attributes: true, attributeFilter: ['open'] });
    window.addEventListener('resize', scheduleUpdate, { passive: true });
    window.addEventListener('ozel-olcu:pattern-bridge-ready', function() { refreshKicker(); scheduleUpdate(); });
    window.addEventListener('pageshow', scheduleUpdate);

    /* ---------- AR butonunu galeri altına taşı ---------- */
    var arTries = 0;
    function moveArButton() {
      var arBtn = document.getElementById('dvb-ar-product-btn');
      if (!arBtn) { if (++arTries < 30) setTimeout(moveArButton, 500); return; }
      if (arBtn.closest('.dvp-ar-line')) return;
      var line = document.createElement('div');
      line.className = 'dvp-ar-line';
      var meta = root.querySelector('.bp-dv-preview-meta');
      var galleryWrap = document.getElementById('bp-gallery-sticky');
      if (meta && meta.parentNode) meta.parentNode.insertBefore(line, meta);
      else if (galleryWrap) galleryWrap.appendChild(line);
      else return;
      line.appendChild(arBtn);
    }
    moveArButton();

    /* ---------- başlat ---------- */
    function hideLegacySections() {
      var secs = document.querySelectorAll('[id^="shopify-section"][id*="__related"], [id^="shopify-section"][id*="__recently"], #bp-complementary');
      for (var i = 0; i < secs.length; i++) secs[i].style.display = 'none';
    }
    function buildBelow() {
      buildBento();
      buildCollectionStrip();
      buildQualityStrip();
      restyleAccordions();
      dedupeAccordions();
      hideLegacySections();
    }
    refreshKicker();
    updateAll();
    buildBelow();
    window.setTimeout(function() { updateAll(); buildBelow(); }, 600);
    window.setTimeout(function() { updateAll(); buildBelow(); }, 1600);
  });
})();

;/* DV_CART_CTA_HOTFIX_20260729 */(function(){if(window.__dvCartCtaHotfix20260729)return;window.__dvCartCtaHotfix20260729=true;var scheduled=false;function getDock(){return document.querySelector('#banner-product[data-dv-order-flow="visual-v3"] .dv-purchase-dock')}function updateInset(){scheduled=false;var dock=getDock();if(!dock)return;var inset=0,vv=window.visualViewport;if(window.innerWidth<768&&vv){inset=Math.max(0,Math.round(window.innerHeight-(vv.height+vv.offsetTop)))}dock.style.setProperty('--dv-keyboard-inset',inset+'px')}function schedule(){if(scheduled)return;scheduled=true;if(window.requestAnimationFrame)window.requestAnimationFrame(updateInset);else setTimeout(updateInset,0)}function start(){schedule();setTimeout(schedule,250);setTimeout(schedule,1000);if(!getDock()&&window.MutationObserver){var observer=new MutationObserver(function(){if(getDock()){observer.disconnect();schedule()}});observer.observe(document.documentElement,{childList:true,subtree:true});setTimeout(function(){observer.disconnect()},5000)}}window.addEventListener('resize',schedule,{passive:true});window.addEventListener('orientationchange',schedule,{passive:true});if(window.visualViewport){window.visualViewport.addEventListener('resize',schedule,{passive:true});window.visualViewport.addEventListener('scroll',schedule,{passive:true})}if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start()})();

/* DV_SAFE_DRAFT_CHECKOUT_20260729 */
